var app;
(function (app) {
    var Bindings;
    (function (Bindings) {
        'use strict';
        ko.bindingHandlers.viewModel = {
            init: function (element, valueAccessor, allBindings, viewModel) {
                var local = ko.unwrap(valueAccessor()) === 'local';
                var $form = $(element);
                viewModel.submit = function () { return $form.submit(); };
                var submitHandler = app.throttle(1000, local ? localSubmitHandler : remoteSubmitHandler);
                $form.parseValidation();
                var validator = $form.data('validator');
                if (validator) {
                    validator.settings.submitHandler = submitHandler;
                }
                else {
                    $form.submit(function (e) {
                        e.preventDefault();
                        submitHandler();
                    });
                }
                function localSubmitHandler() {
                    app.hideErrors();
                    app.progress.show();
                    viewModel.done.apply(viewModel);
                    app.progress.hide();
                }
                function remoteSubmitHandler() {
                    app.hideErrors();
                    app.progress.show();
                    var url = $form.attr('action');
                    var method = $form.attr('method') || 'POST';
                    var data = app.mapping.toJS(viewModel);
                    app.http.request(url, { type: method, data: data })
                        .fail(app.handleErrors)
                        .always(app.progress.hide)
                        .then(viewModel.done.bind(viewModel));
                }
            }
        };
        ko.bindingHandlers.tooltip = {
            init: function (element, valueAccessor) {
                $(element).tooltip(ko.unwrap(valueAccessor()));
            }
        };
        ko.bindingHandlers.tabShow = {
            init: function (element, valueAccessor) {
                $(element).on('show.bs.tab', ko.unwrap(valueAccessor()));
            }
        };
        ko.bindingHandlers.lookup = {
            init: function (element, valueAccessor, allBindings) {
                var options = ko.unwrap(valueAccessor());
                var $element = $(element).typeahead({
                    minLength: 0,
                    delay: 200,
                    source: function (query, process) {
                        options.source(query).done(function (result) {
                            process(ko.utils.arrayMap(result, function (item) { return (item.id + '#' + item.name); }));
                        });
                    },
                    highlighter: function (item) {
                        return item.substr(item.indexOf('#') + 1);
                    },
                    updater: function (item) {
                        var itemObject = getItemObject(item);
                        options.update(itemObject.id);
                        return itemObject.name;
                    }
                });
                var value = allBindings.get('value');
                if (ko.isObservable(value)) {
                    value.subscribe(function (newValue) {
                        var item = $element.typeahead('getActive');
                        if (!item || getItemObject(item).name !== newValue) {
                            value(null);
                            options.update(null);
                        }
                    });
                }
                $element.parent().find('button').click(function () {
                    $element.typeahead('lookup').focus();
                });
                function getItemObject(item) {
                    var index = item.indexOf('#');
                    return {
                        id: item.substr(0, index),
                        name: item.substr(index + 1)
                    };
                }
            }
        };
        ko.bindingHandlers.autocomplete = {
            init: function (element, valueAccessor) {
                var source = ko.unwrap(valueAccessor());
                var skipFilter = false;
                var $element = $(element).typeahead({
                    minLength: 0,
                    delay: 200,
                    source: function (query, process) {
                        source(query).done(function (response) {
                            process(response);
                            skipFilter = false;
                        });
                    },
                    matcher: function (item) {
                        return skipFilter || item.toLowerCase().indexOf(this.query.toLowerCase()) >= 0;
                    },
                    highlighter: function (item) {
                        return item.substr(item.indexOf('#') + 1);
                    },
                    updater: function (item) {
                        return item.substr(0, item.indexOf('#'));
                    }
                });
                $element.parent().find('button').click(function () {
                    skipFilter = true;
                    $element.typeahead('lookup').focus();
                });
            }
        };
        ko.bindingHandlers.listTag = {
            init: function (element, valueAccessor) {
                var model = ko.unwrap(valueAccessor());
                ko.applyBindingsToNode(element, { css: model.css, text: model.name });
            }
        };
        ko.bindingHandlers.rowLink = {
            init: function (element, valueAccessor) {
                var url = valueAccessor();
                if (url && url.length > 0) {
                    $(element)
                        .click(function (e) {
                        if (!e.target || e.target.tagName !== 'INPUT') {
                            e.preventDefault();
                            app.redirect(url);
                        }
                    })
                        .css('cursor', 'pointer');
                }
            }
        };
    })(Bindings = app.Bindings || (app.Bindings = {}));
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    'use strict';
    Globalize.culture(app.culture);
    var dateFormat = '';
    switch (app.culture) {
        case 'lt-LT':
            dateFormat = 'yyyy-mm-dd';
            break;
        case 'ru-RU':
            dateFormat = 'dd.mm.yyyy';
            break;
        case 'en-GB':
            dateFormat = 'dd/mm/yyyy';
            break;
    }
    $.extend($.fn.datepicker.defaults, { autoclose: true, todayHighlight: true, format: dateFormat, language: app.culture });
    $(function () {
        $('[data-provide="vt-calendar"]').click(function () {
            $(this).closest('.input-group').find('.datepicker').focus();
        });
    });
})(app || (app = {}));

var app;
(function (app) {
    var Extenders;
    (function (Extenders) {
        'use strict';
        function parseLocal(value) {
            var timestamp, struct, minutesOffset = 0;
            var numericKeys = [1, 4, 5, 6, 7, 10, 11];
            if ((struct = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::(\d{2}))?)?)?$/.exec(value))) {
                for (var i = 0, k; (k = numericKeys[i]); ++i) {
                    struct[k] = +struct[k] || 0;
                }
                struct[2] = (+struct[2] || 1) - 1;
                struct[3] = +struct[3] || 1;
                if (struct[8] !== 'Z' && struct[9] !== undefined) {
                    minutesOffset = struct[10] * 60 + struct[11];
                    if (struct[9] === '+') {
                        minutesOffset = 0 - minutesOffset;
                    }
                }
                timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
            }
            else {
                timestamp = Date.parse(value);
            }
            return new Date(timestamp + new Date(timestamp).getTimezoneOffset() * 60000);
        }
        function toJSONLocal(value) {
            return Globalize.format(value, 'S');
        }
        ko.extenders.date = function (target, option) {
            var settings = ko.utils.extend({ format: 'd' }, option === true ? {} : option);
            target.value = ko.computed({
                read: function () {
                    var value = target();
                    return value ? parseLocal(value) : null;
                },
                write: function (value) {
                    target(value ? toJSONLocal(value) : null);
                }
            });
            target.formattedValue = ko.computed({
                read: function () {
                    var value = target.value();
                    if (value === null) {
                        return '';
                    }
                    return Globalize.format(value, settings.format);
                },
                write: function (value) {
                    target.value(value ? Globalize.parseDate(value) : null);
                }
            });
            return target;
        };
        ko.extenders.time = function (target, option) {
            var settings = ko.utils.extend({ format: 't' }, option === true ? {} : option);
            target.value = ko.computed({
                read: function () {
                    var value = target();
                    return value ? parseLocal(value) : null;
                },
                write: function (value) {
                    target(value ? toJSONLocal(value) : null);
                }
            });
            target.formattedValue = ko.computed({
                read: function () {
                    var value = target.value();
                    if (value === null) {
                        return '';
                    }
                    return Globalize.format(value, settings.format);
                },
                write: function (value) {
                    target.value(value ? Globalize.parseDate(value) : null);
                }
            });
            return target;
        };
        function decimalAdjust(value, exp) {
            if (exp == null) {
                return value;
            }
            if (+exp === 0) {
                return Math.round(value);
            }
            value = +value;
            exp = +exp;
            // If the value is not a number or the exp is not an integer...
            if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
                return NaN;
            }
            // Shift
            var valueParts = value.toString().split('e');
            value = Math.round(+(valueParts[0] + 'e' + (valueParts[1] ? (+valueParts[1] - exp) : -exp)));
            // Shift back
            valueParts = value.toString().split('e');
            return +(valueParts[0] + 'e' + (valueParts[1] ? (+valueParts[1] + exp) : exp));
        }
        Extenders.decimalAdjust = decimalAdjust;
        ko.extenders.number = function (target, option) {
            var settings = ko.utils.extend({ format: 'N', optionalTrailingZeros: null }, option === true ? {} : option);
            var precision = settings.format.charAt(0).toUpperCase() != 'N' ? null : settings.format.length === 1 ? 2 : parseInt(settings.format.slice(1), 10);
            var optionalTrailingZeros = settings.optionalTrailingZeros != null ? settings.optionalTrailingZeros : precision > 2 ? 2 : null;
            target.value = target;
            target.formattedValue = ko.computed({
                read: function () {
                    var value = target.value();
                    if (value == null) {
                        return '';
                    }
                    var str = Globalize.format(value, settings.format);
                    if (precision != null && optionalTrailingZeros != null && precision > optionalTrailingZeros) {
                        for (var i = 0; i < optionalTrailingZeros; i++) {
                            if (str.charAt(str.length - 1) === '0') {
                                str = str.substr(0, str.length - 1);
                            }
                        }
                    }
                    return str;
                },
                write: function (value) {
                    if (value == null || value.length === 0) {
                        target.value(null);
                    }
                    else {
                        var num = Globalize.parseFloat(value);
                        if (!isNaN(num) && precision != null) {
                            num = decimalAdjust(num, -precision);
                        }
                        if (target.value() != num) {
                            target.value(num);
                        }
                        else {
                            target.formattedValue.notifySubscribers(num);
                        }
                    }
                }
            });
            return target;
        };
    })(Extenders = app.Extenders || (app.Extenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var JQPlugins;
    (function (JQPlugins) {
        $.fn.freezeHeader = function () {
            return this.each(function () {
                var $this = $(this), $t_fixed;
                function init() {
                    $this.wrap('<div />');
                    $t_fixed = $this.clone();
                    $t_fixed.find("tbody").remove().end().find('tfoot').remove().end().addClass("freezeheader").insertBefore($this);
                    $t_fixed.find("tr").addClass("bg-info");
                    resizeFixed();
                }
                function resizeFixed() {
                    $t_fixed.find("th").each(function (index) {
                        $(this).css("width", $this.find("th").eq(index).outerWidth() + "px");
                    });
                }
                function scrollFixed() {
                    var offset = $(this).scrollTop(), tableOffsetTop = $this.offset().top - 50, tableOffsetBottom = tableOffsetTop + $this.height() - $this.find("thead").height();
                    if (offset < tableOffsetTop || offset > tableOffsetBottom)
                        $t_fixed.hide();
                    else if (offset >= tableOffsetTop && offset <= tableOffsetBottom && $t_fixed.is(":hidden"))
                        $t_fixed.show();
                }
                $(window).resize(resizeFixed);
                $(window).scroll(scrollFixed);
                init();
            });
        };
    })(JQPlugins = app.JQPlugins || (app.JQPlugins = {}));
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    'use strict';
    var FolderTree = (function () {
        function FolderTree(params) {
            this.allFoldersOptionName = ko.observable('');
            this.treeFolderList = ko.observableArray();
            this.allFoldersOptionName = params.allFoldersOptionName;
            this.treeFolderId = params.treeFolderId;
            this.treeFolderList = params.treeFolderList;
        }
        return FolderTree;
    }());
    ko.components.register('folder-tree', {
        viewModel: FolderTree,
        template: "\n        <ul class=\"nav nav-main scrollable-filter-list\" id=\"folderAccordion\">\n            <li data-bind=\"css: { active: !treeFolderId() }\"><a href=\"#\" data-bind=\"text: allFoldersOptionName, click: treeFolderId.bind($data, 0)\"></a></li>\n            <!-- ko foreach: treeFolderList -->\n            <li data-bind=\"css: { active: $parent.treeFolderId() == $data.id }\">\n                <a data-bind=\"text: name, attr: { href: '#'+id }, click: $parent.treeFolderId.bind($parent, id)\" data-toggle=\"collapse\" data-parent=\"#folderAccordion\"></a>\n                <ul data-bind=\"foreach: children, attr: { id: id }\" class=\"nav nav-main collapse\">\n                    <li data-bind=\"css: { active: $parents[1].treeFolderId() == $data.id }\">\n                        <a data-bind=\"text: name, attr: { href: '#'+id }, click: $parents[1].treeFolderId.bind($parents[1], id)\" style=\"padding-left: 25px\" href=\"#\"></a>\n                    </li>\n                </ul>\n            </li>\n\t\t    <!-- /ko -->\n        </ul>\n        "
    });
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    'use strict';
    var PageTag = (function () {
        function PageTag(model) {
            var _this = this;
            this.name = ko.observable(null);
            this.css = ko.observable(null);
            this.visible = ko.computed(function () { return _this.name() != null; });
            if (model != null) {
                this.fromJS(model);
            }
            ko.applyBindings(this, document.getElementById('pageTag'));
        }
        PageTag.prototype.fromJS = function (model) {
            this.name(model.name);
            this.css(model.css);
        };
        PageTag.prototype.show = function (css, name) {
            this.name(name);
            this.css(css);
        };
        PageTag.prototype.hide = function () {
            this.name(null);
            this.css(null);
        };
        return PageTag;
    }());
    app.PageTag = PageTag;
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    'use strict';
    var pageSize = 50;
    var PagerViewModel = (function () {
        function PagerViewModel(params) {
            var _this = this;
            this.pages = ko.observableArray([]);
            this.pageIndex = params.pageIndex;
            this.totalCount = params.totalCount;
            this.totalCountMessage = ko.computed(function () {
                var totalCount = _this.totalCount();
                var firstRecord = 0;
                var lastRecord = 0;
                if (totalCount > 0) {
                    firstRecord = ((_this.pageIndex() - 1) * pageSize) + 1;
                    lastRecord = Math.min(firstRecord + pageSize - 1, totalCount);
                }
                return app.messages.Pager_TotalRecords.format(firstRecord, lastRecord, totalCount);
            });
            this.changePage = function (pageIndex) {
                _this.pageIndex(pageIndex);
                ko.postbox.publish('pageChanged');
            };
            this.updatePages(this.pageIndex(), this.totalCount());
            ko.postbox.subscribe('listViewLoaded', function () { return _this.updatePages(_this.pageIndex(), _this.totalCount()); });
        }
        PagerViewModel.prototype.updatePages = function (pageIndex, totalCount) {
            var pageCount = Math.floor(totalCount / pageSize) + (totalCount % pageSize ? 1 : 0);
            if (pageCount === 0) {
                this.pages.removeAll();
                return;
            }
            var pages = [];
            pages.push({ index: 1, title: String(1), active: pageIndex === 1 });
            var firstPage = Math.max(pageIndex - 3, 2);
            var lastPage = firstPage + 6;
            if (lastPage >= pageCount) {
                firstPage = Math.max(firstPage - (lastPage - pageCount + 1), 2);
                lastPage = pageCount - 1;
            }
            for (var i = firstPage; i <= lastPage; i++) {
                pages.push({ index: i, title: String(i), active: i === pageIndex });
            }
            if (pageCount > 1) {
                pages.push({ index: pageCount, title: String(pageCount), active: pageIndex === pageCount });
                if (pages[1].index !== 2) {
                    pages[1].title = '...';
                }
                var lastButOneIndex = pages.length - 2;
                if (pages[lastButOneIndex].index !== pageCount - 1) {
                    pages[lastButOneIndex].title = '...';
                }
            }
            this.pages(pages);
        };
        return PagerViewModel;
    }());
    app.PagerViewModel = PagerViewModel;
    ko.components.register('ko-pager', {
        viewModel: PagerViewModel,
        template: '<div class="row">' +
            '<div class="col-xs-9"><ul class="pagination" style="margin-top: 0" data-bind="foreach: pages">' +
            '<li data-bind="css: { active: active }"><a href="#" data-bind="text: title, click: $parent.changePage.bind($parent, index)"></a></li>' +
            '</ul></div>' +
            '<div class="col-xs-3"><p class="form-control-static text-right" data-bind="text: totalCountMessage"></p></div>' +
            '</div>'
    });
})(app || (app = {}));

// ES6 shim
if (!Array.prototype.find) {
    Array.prototype.find = function (predicate) {
        'use strict';
        if (this == null) {
            throw new TypeError('Array.prototype.find called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;
        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return value;
            }
        }
        return undefined;
    };
}
if (typeof Object.assign != 'function') {
    (function () {
        Object.assign = function (target) {
            'use strict';
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }
            var output = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source !== undefined && source !== null) {
                    for (var nextKey in source) {
                        if (source.hasOwnProperty(nextKey)) {
                            output[nextKey] = source[nextKey];
                        }
                    }
                }
            }
            return output;
        };
    })();
}
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.lastIndexOf(searchString, position) === position;
    };
}
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
        }
        return this.replace(/{(\d+)}/g, function (match, index) { return (typeof args[index] != 'undefined' ? args[index] : match); });
    };
}

'use strict';
$.fn.parseValidation = function () {
    this.removeData('validator').removeData('unobtrusiveValidation');
    $.validator.unobtrusive.parse(this);
    return this;
};
$.validator.setDefaults({
    highlight: function (element) {
        $(element).closest('.form-group').addClass('has-error');
    },
    unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error');
    },
    showErrors: function (errorMap, errorList) {
        this.defaultShowErrors();
        $.each(this.successList, function (index, value) { return $(value).popover('hide'); });
        $.each(errorList, function (index, value) {
            var element = $(value.element);
            var popover = element.data('bs.popover');
            if (!popover) {
                element.popover({
                    trigger: 'manual',
                    placement: 'bottom',
                    template: '<div class="popover"><div class="arrow"></div><div class="popover-content"></div></div>'
                });
                popover = element.data('popover') || element.data('bs.popover');
            }
            popover.options.content = value.message;
            element.popover('show');
        });
    }
});
$.validator.methods.number = function (value, element) {
    return this.optional(element) || !isNaN(Globalize.parseFloat(value));
};
$.validator.methods.range = function (value, element, param) {
    return this.optional(element) || (Globalize.parseFloat(value) >= param[0] && Globalize.parseFloat(value) <= param[1]);
};
$.validator.methods.date = function (value, element) {
    return this.optional(element) || !isNaN(Globalize.parseDate(value));
};

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    'use strict';
    app.messages = {
        Common: {
            BtnOk: 'OK',
            BtnCancel: 'Cancel',
            Error: 'Error',
            FailedToCompleteOperation: 'Failed to complete operation. Please try later.'
        },
        Dialog: {
            Remove_Title: 'Remove record',
            Remove_Content: 'Do you want to remove selected record?',
            RemoveMultiple_Title: 'Remove records',
            RemoveMultiple_Content: 'Do you want to remove records?'
        },
        Tenders: {
            PublishTender: 'Publish tender',
            SuspendTender: 'Suspend tender',
            MsgParticipantsWillHaveToResubmitBids: 'Participants will have to resubmit bids',
            ReminderToSubmitProposals: 'Reminder to submit proposals',
            ReminderToSubmitProposalsText: 'Do you want to send a reminder to selected suppliers to submit proposals? Note: The reminder will not be sent to the selected suppliers who already have submitted a proposal.',
            Suppliers_InvitationToParticipateInTender_Header: 'Invitation to participate in a tender',
            Suppliers_InvitationToParticipateInTender_Text: 'Do you want to resend an invitation to selected suppliers? Note: The invitation will not be sent to the suppliers who are not approved or are already participate in the tender.',
            Suppliers_MsgEmailMissing: 'Please select or provide e-mail address to contact supplier.'
        },
        Tender_Compare_MsgFailedToSaveNote: 'Failed to save note.',
        Tender_Compare_MsgFailedToMakeWinnerSupplier: 'Failed to make a winner supplier.',
        Tender_Details_MsgFailedToSaveNote: 'Failed to save note.',
        Tender_Details_MsgTenderArchived: 'Tender archived.',
        Tender_Details_MsgTenderUnArchived: 'Tender unarchived.',
        Tender_Details_MsgTenderClosed: 'Tender closed.',
        Tender_Details_MsgTenderPublished: 'Tender published.',
        Tender_Details_MsgTenderSuspended: 'Tender suspended.',
        Tender_Details_MsgTenderTimeExtended: 'Tender time extended.',
        Tender_Details_MsgParticipating: 'Participating',
        Tender_Details_MsgReviewed: 'Reviewed',
        Tender_Details_MsgBidPlaced: 'Bid placed',
        Tender_Details_MsgStatusChanged: 'Status changed',
        Tender_Details_MsgStatusNotChanged: 'Status not changed',
        Tender_Details_MsgTypeNotFound: 'Type not found',
        Tender_Details_MsgWaiting: 'Waiting',
        Tender_Details_MsgAccepted: 'Accepted',
        Tender_Details_MsgRejected: 'Rejected',
        Tender_Details_MsgUpdateFolderFaild: 'Error updating project',
        Tender_Details_MsgUpdateOwnerFaild: 'Error updating owner',
        Tender_Details_Messages_MsgFailedToUploadDocument: '<strong>Error.</strong> Failed to upload document.',
        Tender_SearchSuppliers_RemoveSupplier: 'Remove',
        Tender_SearchSuppliers_AddSupplier: 'Add',
        Tender_SearchSuppliers_AddedSupplier: 'Added',
        Tender_Bids_SendReminder: 'Sent',
        Tender_Suppliers_SendInvitation: 'Sent',
        Tender_Documents_MsgFailedToUploadDocument: '<strong>Error.</strong> Failed to upload document.',
        Tender_List_ColStartsAt: 'Starts At',
        Tender_List_ColEndsAt: 'Ends At',
        Tender_List_ColEndedAt: 'Ended At',
        Bid_MsgBidArchived: 'Bid archived.',
        Bid_MsgBidUnarchived: 'Bid unarchived.',
        Bid_MsgRequestSent: 'Request sent',
        Bid_MsgBidSent: 'Bid sent',
        Bid_MsgBidCanceled: 'Bid canceled',
        Bid_MsgPricesSaved: 'Prices saved',
        Bid_MsgFailedToUploadDocument: '<strong>Error.</strong> Failed to upload document.',
        Bid_MsgAnswersSaved: 'Answers saved',
        Bid_MsgFailedToSaveAnswers: 'Failed to save answers.',
        Bid_MsgFailedToRemoveFromBookmarks: 'Failed to remove from bookmarks.',
        Bid_MsgFailedToAddToBookmarks: 'Failed to add to bookmarks.',
        Bid_MsgFaildToSaveNote: 'Faild to save note',
        Bid_List_MsgFailedToSddToBookmarks: 'Failed to add to bookmarks.',
        Bid_List_MsgFailedToRemoveFromBookmarks: 'Failed to remove from bookmarks.',
        Bid_List_MsgFailedToAdd: 'Failed to add.',
        Bid_List_MsgFailedToRemove: 'Failed to remove.',
        Bid_List_ColActive: 'Send until',
        Bid_List_ColArchive: 'Ends',
        Bid_List_ColPublic: 'Published',
        Bid_List_ColBookmarked: 'Send until',
        Bid_Status_Draft: 'Draft',
        Bid_Status_Sent: 'Sent',
        Bid_Status_WaitingForUpdate: 'Waiting for update',
        Bid_Status_Updated: 'Updated',
        Partner_MsgStatusNotChanged: 'Status not changed.',
        Partner_Documents_MsgFailedToUploadDocument: '<strong>Error.</strong> Failed to upload document.',
        Partners: {
            Assign_Partner: 'Partner',
            Import_MsgFailedToUploadFile: '<strong>Error.</strong> Failed to upload document.',
            Import_Importing: 'Importing, please wait',
            Import_Done: 'Done'
        },
        Tag_MsgSuspended: 'Suspended',
        Tag_MsgDraft: 'Draft',
        Pager_TotalRecords: '{0} - {1} of {2}',
        PurchaseOrders: {
            PurchaseOrderStatus_Draft: 'Draft',
            PurchaseOrderStatus_PriceQuotation: 'Price quotation',
            PurchaseOrderStatus_PricesUpdated: 'Prices updated',
            PurchaseOrderStatus_Submitted: 'Submitted',
            PurchaseOrderStatus_Canceled: 'Canceled',
            PurchaseOrderStatus_SupplierCompleted: 'Supplier completed',
            PurchaseOrderStatus_SupplierRejected: 'Supplier rejected',
            PurchaseOrderStatus_SupplierApproved: 'Supplier approved',
            PurchaseRequestStatus_New: 'New'
        },
        PurchaseOrder_Details_MsgPurchaseOrderArchived: 'Purchase order archived.',
        PurchaseOrder_Details_MsgPurchaseOrderUnArchived: 'Purchase order unarchived.',
        PurchaseOrder_Details_MsgPurchaseOrderItemsUpdateDone: 'Purchase order items were updated.',
        PurchaseOrder_List_ColPurchaseRequestName: 'Name',
        PurchaseOrder_List_ColPurchaseOrderSupplierName: 'Supplier name',
        PurchaseOrder_List_OptPurchaseRequestOwnershipMy: 'My purchase requests',
        PurchaseOrder_List_OptPurchaseRequestOwnershipAll: 'All purchase requests',
        PurchaseOrder_List_OptPurchaseOrderOwnershipMy: 'My purchase orders',
        PurchaseOrder_List_OptPurchaseOrderOwnershipAll: 'All purchase orders',
        SupplierPurchaseOrders: {
            SupplierPurchaseOrderStatus_New: 'New',
            SupplierPurchaseOrderStatus_Approved: 'Approved',
            SupplierPurchaseOrderStatus_Completed: 'Completed',
            SupplierPurchaseOrderStatus_Rejected: 'Rejected',
            SupplierPurchaseOrderStatus_PriceQuotation: 'Price quotation',
            SupplierPurchaseOrderStatus_PricesUpdated: 'Prices sent'
        },
        BuyerProducts: {
            Import_MsgFailedToUploadFile: '<strong>Error.</strong> Failed to upload document.',
            Import_Importing: 'Importing, please wait',
            Import_Done: 'Done'
        },
        BuyerCatalogs: {
            BuyerCatalogStatus_Waiting: 'Waiting',
            BuyerCatalogStatus_Approved: 'Active',
            BuyerCatalogStatus_Rejected: 'Rejected',
            BuyerCatalogProductStatus_Added: 'Added'
        },
        SupplierCatalogUsages: {
            SupplierCatalogUsageStatus_Waiting: 'Waiting',
            SupplierCatalogUsageStatus_Approved: 'Approved',
            SupplierCatalogUsageStatus_Rejected: 'Rejected',
            Approve_Catalog_Message_Sent_Done: 'Catalog was successfully approved',
            Reject_Catalog_Message_Sent_Done: 'Catalog was successfully rejected'
        },
        SupplierProducts: {
            Import_MsgFailedToUploadFile: '<strong>Error.</strong> Failed to upload document.',
            Import_Importing: 'Importing, please wait',
            Import_Done: 'Done',
            Activate_Catalog_Done: 'Catalog activated successfully',
            Deactivate_Catalog_Done: 'Catalog deactivated successfully',
            Save_Catalog_Done: 'Catalogs saved successfully',
            Save_Catalog_Fail: 'Catalogs failed to save. Invalid discount (0-100%)'
        },
        PurchaseRequests: {
            PurchaseRequestStatus_Draft: 'Draft',
            PurchaseRequestStatus_WaitingForApproval: 'Waiting for approval',
            PurchaseRequestStatus_Submitted: 'Submitted',
            PurchaseRequestStatus_Canceled: 'Canceled',
            PurchaseRequestStatus_Completed: 'Completed',
            PurchaseRequestStatus_Processing: 'Processing',
            PurchaseRequestStatus_Approved: 'Approved',
            Details_MsgPurchaseRequestArchived: 'Purchase request archived.',
            Details_MsgPurchaseRequestUnArchived: 'Purchase request unarchived.',
            ToOrders_MsgSuccess: 'There were {0} orders created or updated. Please review them in the purchase request orders list and submit for processing.'
        }
    };
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    app.alert = {
        success: function (message, title, timeout) {
            return toastr.success(message, title, { timeOut: timeout || 10000, closeButton: true });
        },
        info: function (message, title, timeout) {
            return toastr.info(message, title, { timeOut: timeout || 10000, closeButton: true });
        },
        error: function (message, title, timeout) {
            return toastr.error(message, title, { timeOut: timeout || 10000, closeButton: true });
        }
    };
    function hideErrors() {
        toastr.clear();
    }
    app.hideErrors = hideErrors;
    ;
    function showErrors(errors) {
        var errorMessage = '';
        $.each(errors, function (index, messages) {
            $.each(messages, function (innerIndex, message) { return errorMessage += '<div>' + message + '</div>\n'; });
        });
        app.alert.error(errorMessage);
    }
    app.showErrors = showErrors;
    ;
    function handleErrors(xhr, defaultMessage) {
        if (defaultMessage === void 0) { defaultMessage = null; }
        var errors = null;
        defaultMessage = defaultMessage || 'Atliekant veiksmą įvyko klaida.';
        if (xhr && xhr.status >= 400 && xhr.status < 500) {
            var result = xhr.responseJSON;
            if (!result && xhr.responseText) {
                try {
                    result = JSON.parse(xhr.responseText);
                }
                catch (ex) {
                }
            }
            if (!result) {
                result = { message: defaultMessage };
            }
            errors = result.modelState || [[result.message]];
        }
        if (!errors) {
            errors = [[defaultMessage]];
        }
        app.showErrors(errors);
    }
    app.handleErrors = handleErrors;
    ;
    app.progress = {
        show: function () {
            $('.vt-load').show();
        },
        hide: function () {
            $('.vt-load').hide();
        }
    };
})(app || (app = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    'use strict';
    function bootstrap(type, data) {
        jQuery(function () {
            var viewModel = new type(data);
            var request = viewModel.activate();
            var promise = Array.isArray(request) ? whenAll(request) : $.when(request);
            promise.then(function () {
                ko.applyBindings(viewModel, document.getElementById('mainContent'));
                $('.vt-init-hide').removeClass('vt-init-hide');
            });
        });
    }
    app.bootstrap = bootstrap;
    function whenAll(requests) {
        return $.when.apply($, requests).then(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return args;
        });
    }
    app.whenAll = whenAll;
    function clientUrl(url) {
        if (url.substr(0, 2) === '~/') {
            url = app.root + url.substr(2);
        }
        return url;
    }
    app.clientUrl = clientUrl;
    function redirect(url) {
        window.location.href = app.clientUrl(url);
    }
    app.redirect = redirect;
    ;
    function applyBindingsWhenDone(requests, model, element) {
        app.progress.show();
        return $.when.apply(this, requests)
            .done(function () {
            ko.applyBindings(model, element);
            $('.vt-init-hide').removeClass('vt-init-hide');
        })
            .always(app.progress.hide);
    }
    app.applyBindingsWhenDone = applyBindingsWhenDone;
    ;
    function throttle(rate, func) {
        var executing = false;
        return function () {
            if (executing) {
                return;
            }
            executing = true;
            setTimeout(function () { executing = false; }, rate);
            func();
        };
    }
    app.throttle = throttle;
    ;
    var IdName = (function () {
        function IdName() {
        }
        return IdName;
    }());
    app.IdName = IdName;
    var IdCodeName = (function (_super) {
        __extends(IdCodeName, _super);
        function IdCodeName() {
            _super.apply(this, arguments);
        }
        return IdCodeName;
    }(IdName));
    app.IdCodeName = IdCodeName;
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    var names = {
        countries: 'datasource.countries',
        currencies: 'datasource.currencies'
    };
    app.datasource = {
        // BuyerCatalogs:
        buyerCatalogFolders: function (allowCreate) {
            return this.treeFolders('BuyerProduct', { showArchived: false, allowCreate: allowCreate });
        },
        buyerCatalogSubFolders: function (parentId) {
            return this.treeFilterFolders('BuyerProduct', parentId);
        },
        buyerCatalogDropdownFolders: function (folderLevel, folderId) {
            return this.treeDropdownFolders('BuyerProduct', folderLevel, folderId);
        },
        // SupplierCatalogs:
        supplierCatalogFolders: function (allowCreate) {
            return this.treeFolders('SupplierProduct', { showArchived: false, allowCreate: allowCreate });
        },
        supplierCatalogSubFolders: function (parentId) {
            return this.treeFilterFolders('SupplierProduct', parentId);
        },
        supplierCatalogDropdownFolders: function (folderLevel, folderId) {
            return this.treeDropdownFolders('SupplierProduct', folderLevel, folderId);
        },
        supplierCatalogFoldersForBuyers: function (orgId) {
            return app.http.get('~/api/folders/treeDatasourceSupplierCatalogFoldersForBuyers', { orgId: orgId });
        },
        supplierCatalogSubFoldersForBuyers: function (parentId, orgId) {
            return app.http.get('~/api/folders/treeFilterDatasourceSupplierCatalogFoldersForBuyers', { parentId: parentId, orgId: orgId });
        },
        // PurchaseRequest:
        purchaseRequestBuyerCatalogFolders: function (folderId, folderLevel) {
            return this.treeDropdownFolders('BuyerProduct', folderLevel, folderId);
        },
        // PurchaseOrder:
        purchaseOrderBuyerCatalogFolders: function (supplierId, folderId, folderLevel) {
            return app.http.get('~/api/folders/purchaseOrderBuyerCatalogFolders', { supplierId: supplierId, folderId: folderId, folderLevel: folderLevel });
        },
        contractFolders: function (allowCreate) {
            return this.folders('Contract', { showArchived: false, allowCreate: allowCreate });
        },
        countries: function () {
            var countries = app.session.getItem(names.countries);
            if (countries !== null) {
                return $.when(countries);
            }
            return app.http.get('~/api/countries/datasource').done(function (result) { return app.session.setItem(names.countries, result); });
        },
        currencies: function () {
            var currencies = app.session.getItem(names.currencies);
            if (currencies !== null) {
                return $.when(currencies);
            }
            return app.http.get('~/api/currencies/datasource').done(function (result) { return app.session.setItem(names.currencies, result); });
        },
        bidFolders: function (allowCreate) {
            return this.folders('Bid', { showArchived: false, allowCreate: allowCreate });
        },
        tenderFolders: function (allowCreate) {
            return this.folders('Project', { showArchived: false, allowCreate: allowCreate });
        },
        partnerFolders: function (allowCreate) {
            return this.folders('Partner', { showArchived: false, allowCreate: allowCreate });
        },
        purchaseRequestFolders: function (allowCreate) {
            return this.folders('PurchaseRequest', { showArchived: false, allowCreate: allowCreate });
        },
        buyerPurchaseOrderFolders: function (allowCreate) {
            return this.folders('BuyerPurchaseOrder', { showArchived: false, allowCreate: allowCreate });
        },
        supplierPurchaseOrderFolders: function (allowCreate) {
            return this.folders('SupplierPurchaseOrder', { showArchived: false, allowCreate: allowCreate });
        },
        folders: function (type, options) {
            options = ko.utils.extend({ showArchived: false, allowCreate: false }, options);
            return app.http.get('~/api/folders/datasource', { folderType: type, getArchived: options.showArchived, allowCreate: options.allowCreate });
        },
        treeFolders: function (type, options) {
            options = ko.utils.extend({ showArchived: false, allowCreate: false }, options);
            return app.http.get('~/api/folders/treeDatasource', { folderType: type, getArchived: options.showArchived, allowCreate: options.allowCreate });
        },
        treeFilterFolders: function (type, parentId) {
            return app.http.get('~/api/folders/treeFilterDatasource', { folderType: type, parentId: parentId });
        },
        treeDropdownFolders: function (type, level, folderId) {
            return app.http.get('~/api/folders/treeDropdownDatasource', { folderType: type, folderLevel: level, folderId: folderId ? folderId : undefined });
        },
        userDeliveryAddresses: function () {
            return app.http.get('~/api/userDeliveryAddresses/datasource');
        },
        users: function () {
            return app.http.get('~/api/users/datasource');
        },
        remoteSystems: function (type) {
            return app.http.get('~/api/sys/organizations/datasourceRemoteSystems', { type: type });
        },
        departments: function () {
            return app.http.get('~/api/departments/datasource');
        }
    };
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    app.dialog = {
        confirm: function (title, content, model) {
            return open({
                title: title,
                content: content,
                buttons: {
                    ok: { title: app.messages.Common.BtnOk, css: 'btn-primary' },
                    cancel: { title: app.messages.Common.BtnCancel, dismiss: true }
                },
                model: model
            });
        },
        confirmRemove: function () {
            return app.dialog.confirm(app.messages.Dialog.Remove_Title, app.messages.Dialog.Remove_Content);
        },
        confirmRemoveMultiple: function () {
            return app.dialog.confirm(app.messages.Dialog.RemoveMultiple_Title, app.messages.Dialog.RemoveMultiple_Content);
        },
        confirmTemplate: function (templateSelector, model) {
            var template = $(templateSelector);
            return app.dialog.confirm(template.data('title'), template.html(), model);
        }
    };
    var template = '<div class="modal fade">' +
        '<div class="modal-dialog">' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
        '<h4 class="modal-title"></h4>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    function createDialog(options, deferred) {
        var command = '';
        var dialog = $(template);
        dialog.find('.modal-title').html(options.title);
        dialog.find('.modal-body').html(options.content);
        var footer = dialog.find('.modal-footer');
        for (var key in options.buttons) {
            if (options.buttons.hasOwnProperty(key)) {
                var buttonOptions = options.buttons[key];
                var button = $('<button type="button" class="btn btn-xs"></button>')
                    .text(buttonOptions.title)
                    .addClass(buttonOptions.css || 'btn-default')
                    .appendTo(footer);
                if (buttonOptions.dismiss) {
                    button.attr('data-dismiss', 'modal');
                }
                else {
                    button.click(function () {
                        command = key;
                        dialog.modal('hide');
                    });
                }
            }
        }
        dialog.appendTo(document.body);
        dialog.modal({ show: false });
        dialog.on('hidden.bs.modal', function () {
            if (command) {
                deferred.resolve(command);
            }
            else {
                deferred.reject();
            }
            dialog.remove();
        });
        if (options.model) {
            ko.applyBindings(options.model, dialog.get(0));
        }
        return dialog;
    }
    function open(options) {
        var deferred = $.Deferred();
        var dialog = createDialog(options, deferred);
        dialog.modal('show');
        return deferred.promise();
    }
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    app.http = {
        request: function (url, options) {
            var settings = $.extend({ type: 'GET', contentType: 'application/json; charset=utf-8' }, options);
            if (settings.data && (settings.type.toUpperCase()) !== 'GET') {
                settings.data = JSON.stringify(settings.data);
            }
            return $.ajax(app.clientUrl(url), settings); // Strip other arguments for whenAll .then(response => response);
        },
        get: function (url, data) {
            return app.http.request(url, { type: 'GET', data: data });
        },
        post: function (url, data) {
            return app.http.request(url, { type: 'POST', data: data });
        },
        put: function (url, data) {
            return app.http.request(url, { type: 'PUT', data: data });
        },
        delete: function (url, data) {
            return app.http.request(url, { type: 'DELETE', data: data });
        },
        getInteractive: function (url, data) {
            app.progress.show();
            return app.http.get(url, data)
                .fail(app.handleErrors)
                .always(app.progress.hide);
        },
        postInteractive: function (url, data) {
            app.progress.show();
            return app.http.post(url, data)
                .fail(app.handleErrors)
                .always(app.progress.hide);
        },
        putInteractive: function (url, data) {
            app.progress.show();
            return app.http.put(url, data)
                .fail(app.handleErrors)
                .always(app.progress.hide);
        },
        deleteInteractive: function (url, data) {
            app.progress.show();
            return app.http.delete(url, data)
                .fail(app.handleErrors)
                .always(app.progress.hide);
        }
    };
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    'use strict';
    app.logger = {
        error: function (message, source, stacktrace) { return app.http.post('~/api/log/error', { message: message, source: source, stacktrace: stacktrace }); }
    };
    window.onerror = function (message, source, line, col) {
        var stacktrace = arguments.length > 4 ? arguments[4].stack : null;
        app.logger.error(String(message), source + " " + line + ":" + col, stacktrace);
        app.alert.error(app.messages.Common.FailedToCompleteOperation, app.messages.Common.Error);
    };
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    app.mapping = {
        map: function (source, target) {
            return map(source, target, false);
        },
        mapObject: mapObject,
        fromJS: function (source, target) {
            return fromJS(source, target, false);
        },
        toJS: function (source) {
            return unmap(source);
        },
        unmapObject: unmapObject
    };
    function map(source, target, isArrayElement) {
        if (target && target['fromJS']) {
            target['fromJS'](source);
            return target;
        }
        var type = getMapType(source);
        switch (type) {
            case 'array':
                return mapArray(source, target);
            case 'object':
                return mapObject(source, target);
            default:
                return mapScalar(source, target, isArrayElement);
        }
    }
    function mapArray(source, target) {
        var factory = target && target.factory ? target.factory : function (item) { return map(item, null, true); };
        var list = source.map(factory);
        if (!target) {
            return list;
        }
        if (ko.isObservable(target)) {
            target(list);
        }
        else {
            target.splice(0, target.length);
            target.push.apply(target, list);
        }
        return target;
    }
    function mapObject(source, target) {
        target = target || {};
        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = map(source[key], target[key], false);
            }
        }
        return target;
    }
    function mapScalar(source, target, isArrayElement) {
        if (isArrayElement || typeof target === 'undefined' || !ko.isObservable(target)) {
            return source;
        }
        target(source);
        return target;
    }
    function fromJS(source, target, isArrayElement) {
        var type = getMapType(source);
        switch (type) {
            case 'array':
                return fromJSArray(source, target);
            case 'object':
                return fromJSObject(source, target);
            default:
                return fromJSScalar(source, target, isArrayElement);
        }
    }
    function fromJSArray(source, target) {
        target = target || ko.observableArray();
        var list = [];
        if (source && source.length) {
            var factory = target.factory;
            for (var i = 0; i < source.length; i++) {
                var sourceElement = source[i];
                var targetElement = factory ? factory(sourceElement) : null;
                list.push(fromJS(sourceElement, targetElement, true));
            }
        }
        target(list);
        return target;
    }
    function fromJSObject(source, target) {
        target = target || {};
        if (target['fromJS']) {
            target['fromJS'](source);
        }
        else {
            for (var key in source) {
                if (source.hasOwnProperty(key)) {
                    target[key] = fromJS(source[key], target[key], false);
                }
            }
        }
        return target;
    }
    function fromJSScalar(source, target, isArrayElement) {
        if (isArrayElement) {
            return source;
        }
        if (target) {
            if (ko.isObservable(target)) {
                target(source);
            }
            return target;
        }
        return ko.observable(source);
    }
    function getMapType(data) {
        if (data === null) {
            return null;
        }
        return data instanceof Date ? 'date' :
            data instanceof Array ? 'array' :
                data instanceof RegExp ? 'regex' :
                    typeof data;
    }
    function unmap(source) {
        if (source === null || source === undefined) {
            return source;
        }
        if (typeof source.toJS === 'function') {
            return source.toJS();
        }
        source = ko.unwrap(source);
        var mapType = getMapType(source);
        switch (mapType) {
            case 'function':
                return undefined;
            case 'array':
                return unmapArray(source);
            case 'object':
                return unmapObject(source);
            default:
                return source;
        }
    }
    function unmapArray(source) {
        return source.map(function (item) { return unmap(item); });
    }
    function unmapObject(source) {
        var result = {};
        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                var value = unmap(source[key]);
                if (value !== undefined) {
                    result[key] = value;
                }
            }
        }
        return result;
    }
})(app || (app = {}));

// ReSharper disable once InconsistentNaming
var app;
(function (app) {
    app.session = {
        setItem: function (name, data) {
            sessionStorage.setItem(name, JSON.stringify(data));
        },
        getItem: function (name) {
            return JSON.parse(sessionStorage.getItem(name));
        },
        removeItem: function (name) {
            sessionStorage.removeItem(name);
        },
        clear: function () {
            sessionStorage.clear();
        }
    };
})(app || (app = {}));

var app;
(function (app) {
    var Accounts;
    (function (Accounts) {
        'use strict';
        var ChangePasswordViewModel = (function () {
            function ChangePasswordViewModel(model) {
                this.css = '';
                this.visible = false;
                this.currentPassword = ko.observable();
                this.newPassword = ko.observable();
                this.retypedNewPassword = ko.observable();
                app.mapping.map(model, this);
            }
            ChangePasswordViewModel.prototype.activate = function () {
            };
            ChangePasswordViewModel.prototype.done = function (result) {
                app.alert.success(result);
                this.currentPassword('');
                this.newPassword('');
                this.retypedNewPassword('');
            };
            return ChangePasswordViewModel;
        }());
        Accounts.ChangePasswordViewModel = ChangePasswordViewModel;
    })(Accounts = app.Accounts || (app.Accounts = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Folders;
    (function (Folders) {
        'use strict';
        var FolderListItemViewModel = (function () {
            function FolderListItemViewModel(model) {
                var _this = this;
                this.latestData = null;
                this.id = ko.observable();
                this.name = ko.observable();
                this.isArchived = ko.observable();
                this.folderType = ko.observable();
                this.inUse = ko.observable();
                this.editing = ko.observable(false);
                this.selected = ko.observable(false);
                this.cancel = function () {
                    _this.update(_this.latestData);
                    _this.editing(false);
                };
                this.edit = function () { return _this.editing(true); };
                this.saveMethod = ko.computed(function () { return _this.id() === 0 ? 'post' : 'put'; });
                this.id(model.id);
                this.update(model);
            }
            FolderListItemViewModel.prototype.done = function (result) {
                this.id(result);
                this.editing(false);
                this.latestData = {
                    name: this.name(),
                    isArchived: this.isArchived(),
                    inUser: this.inUse()
                };
            };
            FolderListItemViewModel.prototype.toJS = function () {
                return { id: this.id(), name: this.name(), isArchived: this.isArchived(), folderType: this.folderType(), inUse: this.inUse() };
            };
            FolderListItemViewModel.prototype.update = function (data) {
                this.name(data.name);
                this.isArchived(data.isArchived);
                this.folderType(data.folderType);
                this.inUse(data.inUse);
                this.latestData = data;
            };
            return FolderListItemViewModel;
        }());
        Folders.FolderListItemViewModel = FolderListItemViewModel;
        var FolderListViewModel = (function () {
            function FolderListViewModel(model) {
                var _this = this;
                this.css = '';
                this.visible = false;
                this.list = ko.observableArray();
                this.selected = ko.computed(function () { return _this.list().filter(function (item) { return item.selected(); }); });
                this.addItem = function () {
                    var item = new FolderListItemViewModel({ id: 0, isArchived: false, folderType: _this.folderType, inUse: false });
                    item.edit();
                    _this.list.push(item);
                    $('[name=name]:last').focus();
                };
                this.cancelEdit = function (item) {
                    if (item.id() === 0) {
                        _this.list.remove(item);
                    }
                    else {
                        item.cancel();
                    }
                };
                this.deleteSelected = function () {
                    var ids = _this.selected().map(function (item) { return item.id(); });
                    app.http.deleteInteractive('~/api/folders', ids).done(function (result) {
                        _this.refresh();
                        if (result) {
                            app.alert.error(result);
                        }
                    });
                };
                this.displayMode = function (item) { return item.editing() ? 'itemEdit' : 'itemDisplay'; };
                this.list.factory = function (item) { return new FolderListItemViewModel(item); };
                app.mapping.mapObject(model, this);
            }
            FolderListViewModel.prototype.activate = function () {
                this.refresh();
                return true;
            };
            FolderListViewModel.prototype.done = function () {
            };
            FolderListViewModel.prototype.refresh = function () {
                var _this = this;
                return app.http.getInteractive("~/api/folders?folderType=" + this.folderType)
                    .done(function (result) { return app.mapping.map(result, _this.list); });
            };
            return FolderListViewModel;
        }());
        Folders.FolderListViewModel = FolderListViewModel;
    })(Folders = app.Folders || (app.Folders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Folders;
    (function (Folders) {
        'use strict';
        var TreeItemViewModel = (function () {
            function TreeItemViewModel(data) {
                var _this = this;
                this.id = ko.observable();
                this.type = null;
                this.parentId = null;
                this.level = 0;
                this.name = null;
                this.isArchived = false;
                this.inUse = false;
                this.editing = ko.observable(false);
                this.selected = ko.observable(false);
                this.saveMethod = ko.computed(function () { return _this.id() ? 'PUT' : 'POST'; });
                app.mapping.mapObject(data, this);
            }
            TreeItemViewModel.prototype.edit = function () {
                this.saveState();
                this.editing(true);
            };
            TreeItemViewModel.prototype.cancel = function () {
                this.restoreState();
                this.editing(false);
            };
            TreeItemViewModel.prototype.done = function (response) {
                this.id(response);
                this.savedState = null;
                this.editing(false);
            };
            TreeItemViewModel.prototype.toJS = function () {
                return {
                    id: this.id(),
                    type: this.type,
                    parentId: this.parentId,
                    name: this.name,
                    isArchived: this.isArchived,
                    inUse: this.inUse
                };
            };
            TreeItemViewModel.prototype.saveState = function () {
                this.savedState = {
                    name: this.name,
                    isArchived: this.isArchived,
                    inUse: this.inUse
                };
            };
            TreeItemViewModel.prototype.restoreState = function () {
                this.name = this.savedState.name;
                this.isArchived = this.savedState.isArchived;
                this.inUse = this.savedState.inUse;
                this.savedState = null;
            };
            return TreeItemViewModel;
        }());
        Folders.TreeItemViewModel = TreeItemViewModel;
        var FolderTreeViewModel = (function () {
            function FolderTreeViewModel(data) {
                var _this = this;
                this.css = '';
                this.visible = false;
                this.list = ko.observableArray();
                this.selected = ko.computed(function () { return _this.list().filter(function (item) { return item.selected(); }); });
                this.addItem = function (parent) {
                    var item = new TreeItemViewModel({
                        type: _this.type,
                        parentId: parent != null ? parent.id() : null,
                        level: parent != null ? parent.level + 1 : 0,
                        isArchived: false,
                        inUse: false
                    });
                    item.edit();
                    if (parent == null) {
                        _this.list.push(item);
                    }
                    else {
                        var index = _this.list.indexOf(parent);
                        _this.list.splice(index + 1, 0, item);
                    }
                };
                this.deleteItem = function (item) {
                    app.dialog.confirmRemove()
                        .then(function () { return app.http.deleteInteractive("~/api/folders", [item.id()]); })
                        .then(function (response) {
                        if (response) {
                            app.alert.error(response);
                        }
                        else {
                            _this.list.remove(item);
                        }
                    });
                };
                this.deleteUnusedItems = function () {
                    app.dialog.confirmRemoveMultiple()
                        .then(function () {
                        app.http.deleteInteractive("~/api/folders/tree/deleteUnused?type=" + _this.type)
                            .done(function () { return _this.refresh(); });
                    });
                };
                this.cancel = function (item) {
                    if (item.id()) {
                        item.cancel();
                    }
                    else {
                        _this.list.remove(item);
                    }
                };
                this.displayMode = function (item) { return item.editing() ? 'itemEdit' : 'itemDisplay'; };
                this.list.factory = function (item) { return new TreeItemViewModel(item); };
                app.mapping.mapObject(data, this);
            }
            FolderTreeViewModel.prototype.activate = function () {
            };
            FolderTreeViewModel.prototype.done = function () {
            };
            FolderTreeViewModel.prototype.refresh = function () {
                var _this = this;
                return app.http.getInteractive("~/api/folders/tree?type=" + this.type + "&name=" + this.name)
                    .done(function (result) {
                    app.mapping.map(result.list, _this.list);
                });
            };
            return FolderTreeViewModel;
        }());
        Folders.FolderTreeViewModel = FolderTreeViewModel;
    })(Folders = app.Folders || (app.Folders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Messages;
    (function (Messages) {
        'use strict';
        var MessageCreateViewModel = (function () {
            function MessageCreateViewModel(tenderId) {
                var _this = this;
                this.tenderId = tenderId;
                this.css = '';
                this.visible = false;
                this.events = new ko.subscribable();
                this.list = ko.observableArray();
                this.documentList = ko.observableArray();
                this.selected = ko.observable();
                this.text = ko.observable();
                this.canSelect = ko.observable(false);
                //---for bids only
                this.organizationName = ko.observable();
                this.organizationId = ko.observable();
                this.send = function () {
                    var recipientId;
                    if (_this.canSelect()) {
                        recipientId = _this.selected() === undefined ? null : _this.selected().id;
                    }
                    else {
                        recipientId = _this.organizationId();
                    }
                    var documentIds = ko.utils.arrayMap(_this.documentList(), function (document) { return document.id; });
                    var data = ({ tenderId: _this.tenderId, threadId: null, recipientId: recipientId, text: _this.text(), documentIds: documentIds });
                    app.http.postInteractive('~/api/messages', data).done(function (result) {
                        _this.text(null);
                        _this.documentList.removeAll();
                        _this.selected('All');
                        _this.events.notifySubscribers(result, 'saved');
                        $('#newMessageWindow').modal('hide');
                    });
                };
                this.addDocument = function () {
                    $('#fileUploadNewMessage').trigger('click');
                };
                this.deleteDocument = function (document) {
                    app.http.delete('~/api/messageDocuments?documentId=' + document.id, document.id)
                        .done(function () { return _this.documentList.remove(document); });
                };
                this.init();
            }
            //---
            MessageCreateViewModel.prototype.load = function () {
                var _this = this;
                this.canSelect(true);
                app.http.get('~/api/messages/organizations?tenderId=' + this.tenderId).done(function (result) { return _this.list(result); });
            };
            MessageCreateViewModel.prototype.loadFromBid = function (organizationModel) {
                this.organizationName(organizationModel.organizationName);
                this.organizationId(organizationModel.organizationId);
            };
            MessageCreateViewModel.prototype.init = function () {
                var _this = this;
                $('#fileUploadNewMessage').fileupload({
                    dataType: 'json',
                    send: function () {
                        var button = $('#uploadDocument');
                        button.prop('disabled', true).attr('data-original-text', button.html()).html('0 %');
                    },
                    done: function (e, data) {
                        _this.documentList.push(data.result);
                    },
                    fail: function () {
                        app.alert.error(app.messages.Tender_Details_Messages_MsgFailedToUploadDocument);
                    },
                    always: function () {
                        var button = $('#uploadDocument');
                        button.prop('disabled', false).html(button.attr('data-original-text'));
                    },
                    progressall: function (e, data) {
                        var progress = Math.round(data.loaded / data.total * 100);
                        $('#uploadDocument').html('' + progress + ' %');
                    }
                });
            };
            return MessageCreateViewModel;
        }());
        Messages.MessageCreateViewModel = MessageCreateViewModel;
    })(Messages = app.Messages || (app.Messages = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Messages;
    (function (Messages) {
        'use strict';
        var MessageViewModel = (function () {
            function MessageViewModel(model) {
                this.sentAt = model.sentAt;
                this.senderName = model.senderName;
                this.text = model.text;
                this.messageDocumentList = ko.utils.arrayMap(model.documents, this.documentListMap);
            }
            MessageViewModel.prototype.documentListMap = function (document) {
                var result = ko.utils.extend({}, document);
                return ko.utils.extend(result, {
                    url: app.clientUrl('~/api/messageDocuments/' + document.id)
                });
            };
            return MessageViewModel;
        }());
        Messages.MessageViewModel = MessageViewModel;
        var MessageListViewModel = (function () {
            function MessageListViewModel(tenderId, viewerName) {
                var _this = this;
                this.tenderId = tenderId;
                this.viewerName = viewerName;
                this.css = '';
                this.visible = false;
                this.events = new ko.subscribable();
                this.threadId = null;
                this.list = ko.observableArray();
                this.documentList = ko.observableArray();
                this.text = ko.observable();
                this.send = function () {
                    var documentIds = _this.documentList().map(function (document) { return document.id; });
                    var data = ({ tenderId: _this.tenderId, threadId: _this.threadId, text: _this.text(), documentIds: documentIds });
                    app.http.postInteractive('~/api/messages', data).done(function (result) {
                        _this.list.push(new MessageViewModel(result));
                        _this.text(null);
                        _this.documentList.removeAll();
                        _this.events.notifySubscribers(result, 'send');
                    });
                };
                this.load = function (id) {
                    var isBider = _this.viewerName === 'bid';
                    _this.threadId = id;
                    app.http.get('~/api/messages', { threadId: id, isBider: isBider }).done(function (result) {
                        _this.list(result.map(function (item) { return new MessageViewModel(item); }));
                        _this.text(null);
                        _this.documentList.removeAll();
                        _this.events.notifySubscribers(result, 'send');
                    });
                };
                this.addDocument = function () {
                    $('#fileUploadNewAnswer').trigger('click');
                };
                this.deleteDocument = function (document) {
                    app.http.delete('~/api/messageDocuments?documentId=' + document.id, document.id).done(function () { return _this.documentList.remove(document); });
                };
                this.init();
            }
            MessageListViewModel.prototype.init = function () {
                var _this = this;
                $('#fileUploadNewAnswer').fileupload({
                    dataType: 'json',
                    send: function () {
                        var button = $('#uploadDocument');
                        button.prop('disabled', true).attr('data-original-text', button.html()).html('0 %');
                    },
                    done: function (e, data) {
                        _this.documentList.push(data.result);
                    },
                    fail: function () {
                        app.alert.error(app.messages.Tender_Details_Messages_MsgFailedToUploadDocument);
                    },
                    always: function () {
                        var button = $('#uploadDocument');
                        button.prop('disabled', false).html(button.attr('data-original-text'));
                    },
                    progressall: function (e, data) {
                        var progress = Math.round(data.loaded / data.total * 100);
                        $('#uploadDocument').html('' + progress + ' %');
                    }
                });
            };
            return MessageListViewModel;
        }());
        Messages.MessageListViewModel = MessageListViewModel;
    })(Messages = app.Messages || (app.Messages = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Partners;
    (function (Partners) {
        'use strict';
        var ImportStats = (function () {
            function ImportStats() {
                this.imported = ko.observable(0);
                this.total = ko.observable(0);
                this.errors = ko.observableArray();
            }
            ImportStats.prototype.reset = function () {
                this.imported(0);
                this.total(0);
                this.errors.removeAll();
            };
            ImportStats.prototype.load = function (data) {
                this.imported(data.imported);
                this.total(data.total);
                this.errors(data.errors);
            };
            return ImportStats;
        }());
        var PartnersImportViewModel = (function () {
            function PartnersImportViewModel() {
                var _this = this;
                this.css = '';
                this.visible = false;
                this.partners = new ImportStats();
                this.contacts = new ImportStats();
                this.uploadDocument = function () {
                    $('.progress-bar').html('').width(0);
                    _this.partners.reset();
                    _this.contacts.reset();
                    $('#fileUpload').trigger('click');
                };
            }
            PartnersImportViewModel.prototype.activate = function () {
                var _this = this;
                $('#fileUpload').fileupload({
                    dataType: 'json',
                    add: function (e, data) {
                        data.url = app.clientUrl('~/api/partners/import');
                        data.process().done(function () { return data.submit(); });
                    },
                    send: function () { return $('.progress-bar').html('0 %').width(0).addClass('active'); },
                    done: function (e, data) {
                        _this.partners.load(data.result.partners);
                        _this.contacts.load(data.result.contacts);
                    },
                    fail: function () { return app.alert.error(app.messages.Partners.Import_MsgFailedToUploadFile); },
                    always: function () { return $('.progress-bar').html(app.messages.Partners.Import_Done).removeClass('active'); },
                    progressall: function (e, data) {
                        var progress = Math.round(data.loaded / data.total * 100);
                        var text = progress < 100 ? '' + progress + ' %' : app.messages.Partners.Import_Importing;
                        $('.progress-bar').html(text).width('' + progress + '%');
                    }
                });
            };
            PartnersImportViewModel.prototype.done = function () {
            };
            return PartnersImportViewModel;
        }());
        Partners.PartnersImportViewModel = PartnersImportViewModel;
    })(Partners = app.Partners || (app.Partners = {}));
})(app || (app = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var PurchaseRequests;
    (function (PurchaseRequests) {
        'use strict';
        (function (PurchaseRequestStatus) {
            PurchaseRequestStatus[PurchaseRequestStatus["Draft"] = 1] = "Draft";
            PurchaseRequestStatus[PurchaseRequestStatus["WaitingForApproval"] = 2] = "WaitingForApproval";
            PurchaseRequestStatus[PurchaseRequestStatus["Submitted"] = 3] = "Submitted";
            PurchaseRequestStatus[PurchaseRequestStatus["Canceled"] = 4] = "Canceled";
            PurchaseRequestStatus[PurchaseRequestStatus["Completed"] = 5] = "Completed";
            PurchaseRequestStatus[PurchaseRequestStatus["Processing"] = 6] = "Processing";
            PurchaseRequestStatus[PurchaseRequestStatus["Approved"] = 7] = "Approved";
        })(PurchaseRequests.PurchaseRequestStatus || (PurchaseRequests.PurchaseRequestStatus = {}));
        var PurchaseRequestStatus = PurchaseRequests.PurchaseRequestStatus;
        var PurchaseRequestPageTag = (function (_super) {
            __extends(PurchaseRequestPageTag, _super);
            function PurchaseRequestPageTag() {
                var _this = this;
                _super.call(this);
                ko.postbox.subscribe('RequestStatus', function (value) { return _this.update(value); });
            }
            PurchaseRequestPageTag.prototype.update = function (status) {
                var model = PurchaseRequestPageTag.map(status);
                this.show(model.css, model.name);
            };
            PurchaseRequestPageTag.map = function (status) {
                switch (status) {
                    case PurchaseRequestStatus[PurchaseRequestStatus.Draft]:
                        return { css: 'label-warning', name: app.messages.PurchaseRequests.PurchaseRequestStatus_Draft };
                    case PurchaseRequestStatus[PurchaseRequestStatus.WaitingForApproval]:
                        return { css: 'label-default', name: app.messages.PurchaseRequests.PurchaseRequestStatus_WaitingForApproval };
                    case PurchaseRequestStatus[PurchaseRequestStatus.Submitted]:
                        return { css: 'label-default', name: app.messages.PurchaseRequests.PurchaseRequestStatus_Submitted };
                    case PurchaseRequestStatus[PurchaseRequestStatus.Canceled]:
                        return { css: 'label-danger', name: app.messages.PurchaseRequests.PurchaseRequestStatus_Canceled };
                    case PurchaseRequestStatus[PurchaseRequestStatus.Completed]:
                        return { css: 'label-success', name: app.messages.PurchaseRequests.PurchaseRequestStatus_Completed };
                    case PurchaseRequestStatus[PurchaseRequestStatus.Processing]:
                        return { css: 'label-info', name: app.messages.PurchaseRequests.PurchaseRequestStatus_Processing };
                    case PurchaseRequestStatus[PurchaseRequestStatus.Approved]:
                        return { css: 'label-success', name: app.messages.PurchaseRequests.PurchaseRequestStatus_Processing };
                    default:
                        return { css: 'hide', name: null };
                }
            };
            return PurchaseRequestPageTag;
        }(app.PageTag));
        PurchaseRequests.PurchaseRequestPageTag = PurchaseRequestPageTag;
    })(PurchaseRequests = app.PurchaseRequests || (app.PurchaseRequests = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Shared;
    (function (Shared) {
        var PermissionModel = (function () {
            function PermissionModel() {
                this.selected = ko.observable();
            }
            return PermissionModel;
        }());
        Shared.PermissionModel = PermissionModel;
        var PermissionsModel = (function () {
            function PermissionsModel() {
                this.css = '';
                this.visible = false;
                this.items = [];
            }
            PermissionsModel.prototype.fromJS = function (data) {
                var groups = data.items.reduce(function (dict, item) {
                    if (!dict[item.group]) {
                        dict[item.group] = [];
                    }
                    var model = new PermissionModel();
                    model.group = item.group;
                    model.name = item.name;
                    model.permission = item.permission;
                    model.selected(item.selected);
                    dict[item.group].push(model);
                    return dict;
                }, {});
                for (var key in groups) {
                    if (groups.hasOwnProperty(key)) {
                        this.items.push(groups[key]);
                    }
                }
            };
            PermissionsModel.prototype.toJS = function () {
                var result = [];
                for (var i = 0; i < this.items.length; i++) {
                    var group = this.items[i];
                    for (var j = 0; j < group.length; j++) {
                        var item = group[j];
                        result.push({ group: item.group, permission: item.permission, name: item.name, selected: item.selected() });
                    }
                }
                return { items: result };
            };
            return PermissionsModel;
        }());
        Shared.PermissionsModel = PermissionsModel;
    })(Shared = app.Shared || (app.Shared = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Shared;
    (function (Shared) {
        var PurchaseAddressEditViewModel = (function () {
            function PurchaseAddressEditViewModel() {
                this.css = '';
                this.visible = false;
                this.organizationName = ko.observable();
                this.organizationRegNr = ko.observable();
                this.street = ko.observable();
                this.city = ko.observable();
                this.postalCode = ko.observable();
                this.countryId = ko.observable();
                this.phone = ko.observable();
                this.countryIdOptions = ko.observableArray();
            }
            PurchaseAddressEditViewModel.prototype.activate = function () {
                return app.datasource.countries().done(this.countryIdOptions);
            };
            PurchaseAddressEditViewModel.prototype.fromJS = function (data) {
                app.mapping.mapObject(data, this);
            };
            PurchaseAddressEditViewModel.prototype.toJS = function () {
                var data = app.mapping.unmapObject(this);
                delete data.countryIdOptions;
                return data;
            };
            PurchaseAddressEditViewModel.prototype.loadDeliveryAddress = function (id) {
                var _this = this;
                return app.http.getInteractive("~/api/userDeliveryAddresses/select/" + id).done(function (address) {
                    _this.organizationName(address.organizationName);
                    _this.organizationRegNr(address.organizationRegNr);
                    _this.street(address.street);
                    _this.city(address.city);
                    _this.postalCode(address.postalCode);
                    _this.countryId(address.countryId);
                    _this.phone(address.phone);
                });
            };
            return PurchaseAddressEditViewModel;
        }());
        Shared.PurchaseAddressEditViewModel = PurchaseAddressEditViewModel;
    })(Shared = app.Shared || (app.Shared = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var AddSuppliersViewModel = (function () {
            function AddSuppliersViewModel(id) {
                var _this = this;
                this.css = '';
                this.visible = false;
                this.returnToTender = function () {
                    var suppliers = _this.suppliers.getInvitedSupplierIds().join(',');
                    app.redirect("~/tenders/details/" + _this.id + "?suppliers=" + suppliers + "#tabSuppliers");
                };
                this.id = id;
                this.suppliers = new Tenders.SearchSuppliersViewModel(id);
            }
            AddSuppliersViewModel.prototype.init = function (element) {
                app.applyBindingsWhenDone([], this, element);
                this.suppliers.init();
            };
            return AddSuppliersViewModel;
        }());
        Tenders.AddSuppliersViewModel = AddSuppliersViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        (function (BidStatus) {
            BidStatus[BidStatus["Draft"] = 1] = "Draft";
            BidStatus[BidStatus["Sent"] = 2] = "Sent";
            BidStatus[BidStatus["WaitingForUpdate"] = 3] = "WaitingForUpdate";
            BidStatus[BidStatus["Updated"] = 4] = "Updated";
        })(Tenders.BidStatus || (Tenders.BidStatus = {}));
        var BidStatus = Tenders.BidStatus;
        var BidStatusPageTag = (function (_super) {
            __extends(BidStatusPageTag, _super);
            function BidStatusPageTag() {
                var _this = this;
                _super.call(this);
                ko.postbox.subscribe('BidStatus', function (value) { return _this.update(value); });
            }
            BidStatusPageTag.prototype.update = function (bidStatus) {
                var model = BidStatusPageTag.map(bidStatus);
                this.show(model.css, model.name);
            };
            BidStatusPageTag.map = function (bidStatus) {
                switch (bidStatus) {
                    case BidStatus[BidStatus.Draft]:
                        return { css: 'label-default', name: app.messages.Bid_Status_Draft };
                    case BidStatus[BidStatus.Sent]:
                        return { css: 'label-primary', name: app.messages.Bid_Status_Sent };
                    case BidStatus[BidStatus.WaitingForUpdate]:
                        return { css: 'label-warning', name: app.messages.Bid_Status_WaitingForUpdate };
                    case BidStatus[BidStatus.Updated]:
                        return { css: 'label-primary', name: app.messages.Bid_Status_Updated };
                    default:
                        return { css: 'hide', name: null };
                }
            };
            BidStatusPageTag.mapList = function (bidStatus) {
                if (bidStatus) {
                    return BidStatusPageTag.map(bidStatus);
                }
                return { css: 'hide', name: null };
            };
            return BidStatusPageTag;
        }(app.PageTag));
        Tenders.BidStatusPageTag = BidStatusPageTag;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderWinnerItemsViewModel = (function () {
            function TenderWinnerItemsViewModel(data) {
                this.selectedQuantity = ko.observable().extend({ number: true });
                app.mapping.mapObject(data, this);
            }
            return TenderWinnerItemsViewModel;
        }());
        Tenders.TenderWinnerItemsViewModel = TenderWinnerItemsViewModel;
        var TenderWinnerViewModel = (function () {
            function TenderWinnerViewModel(model) {
                this.items = ko.observableArray();
                this.winner = model.winner;
                this.isAllItems = model.isAllItems;
                this.items(model.items);
                this.items(model.items.map(function (item) { return new TenderWinnerItemsViewModel(item); }));
            }
            return TenderWinnerViewModel;
        }());
        Tenders.TenderWinnerViewModel = TenderWinnerViewModel;
        var TenderCloseViewModel = (function () {
            function TenderCloseViewModel(model) {
                var _this = this;
                this.css = '';
                this.visible = false;
                this.notifyWinners = ko.observable(true);
                this.notifyOthers = ko.observable(true);
                this.winnersList = ko.observableArray();
                this.othersList = ko.observableArray();
                this.closeTender = function () {
                    $('#closeTender').button('loading');
                    var data = ({ NotifyWinners: _this.notifyWinners(), NotifyOthers: _this.notifyOthers() });
                    app.http.postInteractive('~/api/tenders/{0}/close'.format(_this.tenderId), data)
                        .done(function () { return app.redirect('~/tenders/details/' + _this.tenderId); })
                        .always(function () { return setTimeout(function () { return $('#closeTender').button('reset'); }, 500); });
                };
                this.tenderId = model.id;
                this.winnersList(model.winners.map(function (item) { return new TenderWinnerViewModel(item); }));
                this.othersList(model.others);
            }
            TenderCloseViewModel.prototype.init = function (element) {
                ko.applyBindings(this, element);
            };
            return TenderCloseViewModel;
        }());
        Tenders.TenderCloseViewModel = TenderCloseViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        (function (PriceState) {
            PriceState[PriceState["Normal"] = 0] = "Normal";
            PriceState[PriceState["Best"] = 1] = "Best";
            PriceState[PriceState["Second"] = 2] = "Second";
            PriceState[PriceState["Extremum"] = 3] = "Extremum";
        })(Tenders.PriceState || (Tenders.PriceState = {}));
        var PriceState = Tenders.PriceState;
        var TenderCompareGroupItemViewModel = (function () {
            function TenderCompareGroupItemViewModel(name, items) {
                this.items = ko.observableArray();
                this.name = name;
                this.items(items);
            }
            return TenderCompareGroupItemViewModel;
        }());
        Tenders.TenderCompareGroupItemViewModel = TenderCompareGroupItemViewModel;
        var TenderCompareNotesViewModel = (function () {
            function TenderCompareNotesViewModel(data) {
                this.id = ko.observable();
                this.id(data.id);
                this.index = data.index;
                this.note = data.note;
            }
            return TenderCompareNotesViewModel;
        }());
        Tenders.TenderCompareNotesViewModel = TenderCompareNotesViewModel;
        var TenderCompareItemPriceViewModel = (function () {
            function TenderCompareItemPriceViewModel(data) {
                var _this = this;
                this.isWinner = ko.observable(false);
                this.isDisabled = ko.observable();
                this.suggestedQuantity = ko.observable().extend({ number: true });
                this.selectedQuantity = ko.observable().extend({ number: true });
                this.unitPrice = ko.observable().extend({ number: true });
                this.totalPrice = ko.observable().extend({ number: true });
                this.totalSuggestedPrice = ko.observable().extend({ number: true });
                this.totalSelectedPrice = ko.computed(function () { return _this.calcTotalSelectedPrice(); }).extend({ number: true });
                this.selectedExceedsSuggested = ko.computed(function () { return _this.selectedQuantity() > _this.suggestedQuantity(); });
                this.priceState = ko.observable(PriceState.Normal);
                this.css = ko.pureComputed(function () {
                    if (_this.isWinner()) {
                        return 'bg-success';
                    }
                    if (_this.priceState() === PriceState.Best) {
                        return 'bg-success';
                    }
                    if (_this.priceState() === PriceState.Second) {
                        return 'bg-warning';
                    }
                    if (_this.priceState() === PriceState.Extremum) {
                        return 'bg-danger';
                    }
                    return null;
                });
                app.mapping.mapObject(data, this);
                this.isWinner.subscribe(function () { return ko.postbox.publish('isItemWinnerChanged', _this); });
                this.selectedQuantity.subscribe(function () { return ko.postbox.publish('selectedQuantityChanged', _this); });
            }
            TenderCompareItemPriceViewModel.prototype.calcTotalSelectedPrice = function () {
                return this.selectedQuantity() * this.unitPrice();
            };
            return TenderCompareItemPriceViewModel;
        }());
        Tenders.TenderCompareItemPriceViewModel = TenderCompareItemPriceViewModel;
        var TenderCompareItemViewModel = (function () {
            function TenderCompareItemViewModel(data) {
                var _this = this;
                this.quantity = ko.observable().extend({ number: true });
                this.itemPrices = ko.observableArray();
                this.totalSuggestedQuantity = ko.computed(function () { return _this.calcTotalSuggestedQuantity(); }).extend({ number: true });
                this.totalSelectedQuantity = ko.computed(function () { return _this.calcTotalSelectedQuantity(); }).extend({ number: true });
                this.suggestedQuantityDiff = ko.computed(function () { return _this.totalSuggestedQuantity() - _this.quantity(); }).extend({ number: true });
                this.selectedQuantityDiff = ko.computed(function () { return _this.totalSelectedQuantity() - _this.quantity(); }).extend({ number: true });
                this.suggestedDiffCss = ko.computed(function () { return _this.suggestedQuantityDiff() < 0 ? 'vt-text-danger' : 'vt-text-muted'; });
                this.selectedDiffCss = ko.computed(function () { return _this.selectedQuantityDiff() !== 0 ? 'vt-text-danger' : 'vt-text-muted'; });
                this.itemPrices.factory = function (item) { return new TenderCompareItemPriceViewModel(item); };
                app.mapping.mapObject(data, this);
            }
            TenderCompareItemViewModel.prototype.calcTotalSuggestedQuantity = function () {
                var itemPrices = this.itemPrices();
                return itemPrices.map(function (itemPrice) {
                    if (!itemPrice.isDisabled()) {
                        return itemPrice.suggestedQuantity();
                    }
                    return 0.0;
                }).reduce(function (x, y) { return x + y; }, 0.0);
            };
            TenderCompareItemViewModel.prototype.calcTotalSelectedQuantity = function () {
                return this.itemPrices().map(function (item) { return Number(item.selectedQuantity()); }).filter(function (item) { return item != null; }).reduce(function (x, y) { return x + y; }, 0);
            };
            return TenderCompareItemViewModel;
        }());
        Tenders.TenderCompareItemViewModel = TenderCompareItemViewModel;
        var TenderCompareAnswersViewModel = (function () {
            function TenderCompareAnswersViewModel(data, parent) {
                this.documents = ko.observableArray();
                this.documents.factory = function (item) { return app.mapping.mapObject(item, { url: app.clientUrl("~/api/tenderBids/document/" + item.id) }); };
                app.mapping.mapObject(data, this);
                this.isWinner = parent.suppliers()[this.index].isWinner;
                this.hasComment = this.comment != null && this.comment.length >= 1;
            }
            return TenderCompareAnswersViewModel;
        }());
        Tenders.TenderCompareAnswersViewModel = TenderCompareAnswersViewModel;
        var TenderCompareQuestionsViewModel = (function () {
            function TenderCompareQuestionsViewModel(data, parent) {
                this.answers = ko.observableArray();
                this.answers.factory = function (item) { return new TenderCompareAnswersViewModel(item, parent); };
                app.mapping.mapObject(data, this);
            }
            return TenderCompareQuestionsViewModel;
        }());
        Tenders.TenderCompareQuestionsViewModel = TenderCompareQuestionsViewModel;
        var TenderCompareTotalPriceViewModel = (function () {
            function TenderCompareTotalPriceViewModel(item) {
                this.totalPrice = ko.observable().extend({ number: true });
                app.mapping.mapObject(item, this);
            }
            return TenderCompareTotalPriceViewModel;
        }());
        Tenders.TenderCompareTotalPriceViewModel = TenderCompareTotalPriceViewModel;
        var TenderCompareSupplierViewModel = (function () {
            function TenderCompareSupplierViewModel(data) {
                var _this = this;
                this.isNotConsidered = ko.observable();
                this.totalPrice = ko.observable().extend({ number: true });
                this.isWinner = ko.observable();
                this.isDisabled = ko.observable();
                this.addInSupplierList = function () {
                    app.http.post("~/api/tenderBids/isNotConsidered?bidId=" + _this.id, false)
                        .done(function () {
                        _this.isNotConsidered(false);
                        _this.compareLaytoutService.setHeights();
                    })
                        .fail(function () { return app.alert.error(app.messages.Bid_List_MsgFailedToAdd + _this.supplierName); });
                };
                this.removeFromSuppliersList = function () {
                    app.http.post("~/api/tenderBids/isNotConsidered?bidId=" + _this.id, true)
                        .done(function () {
                        _this.isNotConsidered(true);
                        if (_this.isWinner()) {
                            _this.isWinner(false);
                        }
                        _this.compareLaytoutService.setHeights();
                    })
                        .fail(function () { return app.alert.error(app.messages.Bid_List_MsgFailedToRemove + _this.supplierName); });
                };
                app.mapping.mapObject(data, this);
                this.isWinner.subscribe(function () { return ko.postbox.publish('isSupplierWinnerChanged', _this); });
                this.isNotConsidered.subscribe(function () { return ko.postbox.publish('isNotConsidered', _this); });
                this.compareLaytoutService = new CompareLayoutService;
            }
            return TenderCompareSupplierViewModel;
        }());
        Tenders.TenderCompareSupplierViewModel = TenderCompareSupplierViewModel;
        var TenderCompareViewModel = (function () {
            function TenderCompareViewModel(model) {
                var _this = this;
                this.css = '';
                this.visible = false;
                this.parentIsWinnerNotificationsEnabled = true;
                this.childIsWinnerNotificationsEnabled = true;
                this.tenderStatus = ko.observable();
                this.arePartialOrdersAllowed = ko.observable();
                this.currency = ko.observable();
                this.priceThreshold = ko.observable().extend({ number: true });
                this.items = [];
                this.groupedList = ko.observableArray();
                this.suppliers = ko.observableArray();
                this.consideredSuppliers = ko.computed(function () { return _this.suppliers().filter(function (item) { return !item.isNotConsidered(); }); });
                this.questions = ko.observableArray();
                this.totalPrices = [];
                this.notes = [];
                this.notConsideredBids = ko.computed(function () { return _this.suppliers().filter(function (item) { return item.isNotConsidered(); }); });
                this.saveNote = function (values) {
                    app.http.postInteractive("~/api/tenderBids/notes?bidId=" + values.id(), values.note)
                        .fail(function () { return app.alert.error(app.messages.Tender_Compare_MsgFailedToSaveNote); });
                };
                this.displayMode = function (display) {
                    switch (display.questionType) {
                        case 'Upload':
                            return 'uploadDisplay';
                        case 'MultiChoice':
                            return 'multiChoice';
                        case 'YesNo':
                            return 'yesNoChoice';
                        case 'SingleChoice':
                            return 'singleChoice';
                        default:
                            return 'elseDisplay';
                    }
                };
                this.totalPriceSelectedItems = ko.observable(0).extend({ number: true });
                this.updateItemPriceStates = function () {
                    var suppliers = _this.suppliers();
                    for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
                        var item = _a[_i];
                        var sum = 0;
                        var count = 0;
                        var latestItemPrice;
                        for (var _b = 0, _c = item.itemPrices(); _b < _c.length; _b++) {
                            var itemPrice = _c[_b];
                            var supplier = suppliers[itemPrice.index];
                            itemPrice.priceState(PriceState.Normal);
                            if (supplier.isNotConsidered() || itemPrice.unitPrice() == null) {
                                continue;
                            }
                            sum += itemPrice.unitPrice();
                            latestItemPrice = itemPrice;
                            count++;
                        }
                        if (count === 1) {
                            latestItemPrice.priceState(PriceState.Best);
                            continue;
                        }
                        if (count < 2) {
                            continue;
                        }
                        var avg = sum / count;
                        var minLimit = avg - avg * _this.priceThreshold() / 100;
                        var maxLimit = avg + avg * _this.priceThreshold() / 100;
                        var bestPrice = null;
                        var secondPrice = null;
                        for (var _d = 0, _e = item.itemPrices(); _d < _e.length; _d++) {
                            var itemPrice = _e[_d];
                            var supplier = suppliers[itemPrice.index];
                            if (supplier.isNotConsidered()) {
                                continue;
                            }
                            var price = itemPrice.unitPrice();
                            if (price == null) {
                                continue;
                            }
                            if (price <= minLimit || price >= maxLimit) {
                                itemPrice.priceState(PriceState.Extremum);
                            }
                            else {
                                itemPrice.priceState(PriceState.Normal);
                                if (bestPrice == null) {
                                    bestPrice = itemPrice;
                                }
                                else if (bestPrice.unitPrice() > price) {
                                    secondPrice = bestPrice;
                                    bestPrice = itemPrice;
                                }
                                else if (secondPrice == null) {
                                    secondPrice = itemPrice;
                                }
                                else if (secondPrice.unitPrice() > price) {
                                    secondPrice = itemPrice;
                                }
                            }
                        }
                        if (bestPrice != null) {
                            bestPrice.priceState(PriceState.Best);
                        }
                        if (secondPrice != null) {
                            secondPrice.priceState(PriceState.Second);
                        }
                    }
                };
                this.items.factory = function (item) { return new TenderCompareItemViewModel(item); };
                this.suppliers.factory = function (item) { return new TenderCompareSupplierViewModel(item); };
                this.questions.factory = function (item) { return new TenderCompareQuestionsViewModel(item, _this); };
                this.totalPrices.factory = function (item) { return new TenderCompareTotalPriceViewModel(item); };
                this.notes.factory = function (item) { return new TenderCompareNotesViewModel(item); };
                app.mapping.mapObject(model, this);
                this.updateSelectedTotalPrice();
                this.consideredSuppliers.subscribe(function () {
                    _this.updateItemPriceStates();
                    _this.updateSelectedTotalPrice();
                });
                this.compareLaytoutService = new CompareLayoutService();
            }
            TenderCompareViewModel.prototype.init = function (element) {
                var _this = this;
                ko.applyBindings(this, element);
                ko.postbox.subscribe('isItemWinnerChanged', function (item) {
                    if (!_this.childIsWinnerNotificationsEnabled) {
                        return;
                    }
                    app.http.post("~/api/tenderBids/isChecked?bidItemPriceId=" + item.bidItemPriceId, item.isWinner())
                        .done(function () {
                        if (!_this.arePartialOrdersAllowed()) {
                            var aItem = _this.items.filter(function (x) { return x.itemPrices().filter(function (i) { return i.bidItemPriceId == item.bidItemPriceId; })[0] != null; })[0];
                            for (var _i = 0, _a = aItem.itemPrices(); _i < _a.length; _i++) {
                                var itemPrice = _a[_i];
                                if (itemPrice.bidItemPriceId != item.bidItemPriceId)
                                    itemPrice.isDisabled(item.isWinner());
                            }
                        }
                        var parentIsWinner = _this.items.some(function (line) { return line.itemPrices()[item.index].isWinner(); });
                        _this.parentIsWinnerNotificationsEnabled = false;
                        _this.suppliers()[item.index].isWinner(parentIsWinner);
                        _this.updateSelectedTotalPrice();
                        _this.parentIsWinnerNotificationsEnabled = true;
                        var bidItemPriceId = item.bidItemPriceId;
                        for (var _b = 0, _c = _this.items; _b < _c.length; _b++) {
                            var item_1 = _c[_b];
                            for (var _d = 0, _e = item_1.itemPrices(); _d < _e.length; _d++) {
                                var itemPrice = _e[_d];
                                if (itemPrice.bidItemPriceId === bidItemPriceId) {
                                    itemPrice.selectedQuantity(null);
                                }
                            }
                        }
                    })
                        .fail(function (response) {
                        // item.isWinner(!item.isWinner()); // TODO: ciklas amzinas
                        app.handleErrors(response);
                    });
                });
                ko.postbox.subscribe('selectedQuantityChanged', function (item) {
                    var bidObject = { id: item.bidItemPriceId, selectedQuantity: item.selectedQuantity() };
                    var url = '~/api/tenderBids?bidItemPriceId={0}'.format(item.bidItemPriceId);
                    app.http.postInteractive(url, bidObject)
                        .done(function () {
                        _this.updateSelectedTotalPrice();
                    })
                        .fail(function (response) {
                        app.handleErrors(response);
                    });
                });
                ko.postbox.subscribe('isSupplierWinnerChanged', function (bid) {
                    if (!_this.parentIsWinnerNotificationsEnabled) {
                        return;
                    }
                    //this.childIsWinnerNotificationsEnabled = false;
                    for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
                        var item = _a[_i];
                        for (var _b = 0, _c = item.itemPrices(); _b < _c.length; _b++) {
                            var itemPrice = _c[_b];
                            if (itemPrice.bidId === bid.id) {
                                itemPrice.isWinner(bid.isWinner());
                            }
                        }
                    }
                    //this.childIsWinnerNotificationsEnabled = true;
                    app.http.post("~/api/tenderBids/isWinner?bidId=" + bid.id, bid.isWinner())
                        .done(function () {
                        _this.updateSelectedTotalPrice();
                        for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
                            var item = _a[_i];
                            for (var _b = 0, _c = item.itemPrices(); _b < _c.length; _b++) {
                                var itemPrice = _c[_b];
                                if (itemPrice.bidId === bid.id) {
                                    itemPrice.selectedQuantity(null);
                                }
                            }
                        }
                    })
                        .fail(function () {
                        bid.isWinner(!bid.isWinner());
                        app.alert.error(app.messages.Tender_Compare_MsgFailedToMakeWinnerSupplier + bid.supplierName);
                    });
                });
                ko.postbox.subscribe('isNotConsidered', function (bid) {
                    for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
                        var item = _a[_i];
                        for (var _b = 0, _c = item.itemPrices(); _b < _c.length; _b++) {
                            var itemPrice = _c[_b];
                            if (itemPrice.bidId === bid.id) {
                                itemPrice.selectedQuantity(null);
                                itemPrice.isDisabled(bid.isNotConsidered());
                            }
                        }
                    }
                });
                this.groupedList(this.groupItemList());
                this.updateItemPriceStates();
                if (!this.arePartialOrdersAllowed()) {
                    var items = this.items.filter(function (x) { return x.itemPrices().filter(function (i) { return i.isWinner() == true; })[0] != null; });
                    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                        var item = items_1[_i];
                        var priceItem = item.itemPrices().filter(function (i) { return i.isWinner() == true; })[0];
                        for (var _a = 0, _b = item.itemPrices(); _a < _b.length; _a++) {
                            var itemPrice = _b[_a];
                            if (itemPrice.bidItemPriceId != priceItem.bidItemPriceId)
                                itemPrice.isDisabled(priceItem.isWinner());
                        }
                    }
                }
                this.compareLaytoutService.init();
            };
            TenderCompareViewModel.prototype.groupItemList = function () {
                var index = {}, group = [];
                ko.utils.arrayForEach(this.items, function (ti) {
                    var itemGroup = ko.unwrap(ti.group) || '';
                    if (!index.hasOwnProperty(itemGroup)) {
                        index[itemGroup] = new TenderCompareGroupItemViewModel(itemGroup, []);
                        group.push(index[itemGroup]);
                    }
                    index[itemGroup].items.push(ti);
                });
                return group.sort(function (a, b) { return a.name.localeCompare(b.name); });
            };
            TenderCompareViewModel.prototype.updateSelectedTotalPrice = function () {
                var sum = 0;
                for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    for (var _b = 0, _c = item.itemPrices(); _b < _c.length; _b++) {
                        var itemPrice = _c[_b];
                        if (itemPrice.isWinner()) {
                            if (this.arePartialOrdersAllowed()) {
                                sum += itemPrice.unitPrice() * itemPrice.selectedQuantity();
                            }
                            else {
                                sum += itemPrice.totalPrice();
                            }
                        }
                    }
                }
                this.totalPriceSelectedItems(sum);
            };
            return TenderCompareViewModel;
        }());
        Tenders.TenderCompareViewModel = TenderCompareViewModel;
        var CompareLayoutService = (function () {
            function CompareLayoutService() {
                var _this = this;
                this.handleScroll = function () {
                    var parent = $("#compareTable0");
                    $('#compareTable1').css('top', parent.scrollTop() + 'px');
                    $('#compareTable1').css('left', parent.scrollLeft() + 'px');
                    $('#compareTable2').css('top', parent.scrollTop() + 'px');
                    $('#compareTable3').css('left', parent.scrollLeft() + 'px');
                };
                this.handleResize = function () {
                    $('#compareTable0').height($(window).height() - 250);
                    _this.setHeights();
                };
            }
            CompareLayoutService.prototype.init = function () {
                this.handleResize();
                $("#compareTable0").scroll(this.handleScroll);
                $(window).resize(this.handleResize);
            };
            CompareLayoutService.prototype.setHeights = function () {
                this.setCellHeights('[id^="itemCell"]');
                this.setCellHeights('[id^="questionCell"]');
            };
            CompareLayoutService.prototype.setCellHeights = function (selector) {
                var itemCellsIds = [];
                $(selector).each(function () { itemCellsIds.push($(this).attr('id')); });
                itemCellsIds = jQuery.unique(itemCellsIds);
                var itemCells = [];
                $(selector).each(function () { itemCells.push($(this)); });
                var itemCellsHeight = [];
                $.each(itemCellsIds, function (i, id) {
                    var height = 0;
                    $.each(itemCells, function (c, el) {
                        if (id === el.attr('id')) {
                            if (height < el.height()) {
                                height = el.height();
                            }
                        }
                    });
                    itemCellsHeight.push({ id: id, height: height });
                });
                $.each(itemCellsHeight, function (i, cell) {
                    $.each(itemCells, function (c, el) {
                        if (cell.id === el.attr('id')) {
                            el.height(cell.height);
                        }
                    });
                });
            };
            return CompareLayoutService;
        }());
        Tenders.CompareLayoutService = CompareLayoutService;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderCreateViewModel = (function () {
            function TenderCreateViewModel(model) {
                var _this = this;
                this.css = '';
                this.visible = false;
                this.categorySource = function (query) { return app.http.get('~/api/cpvs/lookup', { query: query }); };
                this.plannedStartDate = ko.observable().extend({ date: true });
                this.plannedStartTime = ko.observable().extend({ time: true });
                this.endDate = ko.observable().extend({ date: true });
                this.endTime = ko.observable().extend({ time: true });
                this.projectId = ko.observable();
                this.projectIdOptions = ko.observableArray();
                this.ownerIdOptions = ko.observableArray();
                this.currencyIdOptions = ko.observableArray();
                this.publicityOptions = ko.observableArray();
                this.showNewProjectName = ko.computed(function () { return _this.projectId() === 0; });
                app.mapping.fromJS(model, this);
            }
            TenderCreateViewModel.prototype.init = function (element) {
                var requests = [
                    app.datasource.tenderFolders(true).done(this.projectIdOptions),
                    app.datasource.users().done(this.ownerIdOptions),
                    app.datasource.currencies().done(this.currencyIdOptions)
                ];
                app.applyBindingsWhenDone(requests, this, element);
            };
            TenderCreateViewModel.prototype.done = function (result) {
                app.redirect("~/tenders/edit/" + result);
            };
            return TenderCreateViewModel;
        }());
        Tenders.TenderCreateViewModel = TenderCreateViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderDetailsBidViewModel = (function () {
            function TenderDetailsBidViewModel(model) {
                this.id = model.id;
                this.bidDate = model.bidDate;
                this.biderId = model.biderId;
                this.biderName = model.biderName;
                this.totalPrice = ko.observable(model.totalPrice).extend({ number: true });
                this.isChecked = ko.observable(false);
                this.isVisible = model.status !== 'Sent';
                this.bidStatus = model.bidStatus;
                this.isWinnerColor = ko.computed(function () { return model.isWinner ? 'success' : ''; });
                this.lastMessage = model.lastMessage;
            }
            return TenderDetailsBidViewModel;
        }());
        Tenders.TenderDetailsBidViewModel = TenderDetailsBidViewModel;
        var TenderDetailsBidListViewModel = (function () {
            function TenderDetailsBidListViewModel(model) {
                var _this = this;
                this.list = ko.observableArray();
                this.tenderStatus = ko.observable().subscribeTo('TenderStatus', true);
                this.statusIsSendList = ko.observableArray();
                this.isEnabledOpenRemindButton = ko.computed(function () { return _this.list().some(function (item) { return item.isChecked(); }); });
                this.openRemindWindow = function () {
                    app.dialog.confirm(app.messages.Tenders.ReminderToSubmitProposals, app.messages.Tenders.ReminderToSubmitProposalsText).done(function () { return ko.postbox.publish('msgSendReminders'); });
                };
                this.tenderId = model.id;
                this.isVisibleSecretsDeals = ko.observable(model.isVisibleSecretsDeals);
                this.canCompare = ko.computed(function () { return (_this.tenderStatus() === 'Active' || _this.tenderStatus() === 'Closed') && _this.isVisibleSecretsDeals(); });
            }
            TenderDetailsBidListViewModel.prototype.load = function () {
                var _this = this;
                app.http.get('~/api/tenderbids?tenderId=' + this.tenderId).done(function (result) {
                    _this.list(ko.utils.arrayMap(result, function (item) { return new TenderDetailsBidViewModel(item); }));
                    _this.statusIsSendList(ko.utils.arrayFilter(_this.list(), function (item) { return item.bidStatus === 'Sent' || item.bidStatus === 'WaitingForUpdate' || item.bidStatus === 'Updated'; }));
                });
            };
            return TenderDetailsBidListViewModel;
        }());
        Tenders.TenderDetailsBidListViewModel = TenderDetailsBidListViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderDetailsNotesViewModel = (function () {
            function TenderDetailsNotesViewModel(model) {
                this.tenderId = model.id;
                this.text = ko.observable(model.note);
            }
            TenderDetailsNotesViewModel.prototype.save = function () {
                $('#saveNote').button('loading');
                app.http.put('~/api/tendernotes?tenderId=' + this.tenderId, this.text())
                    .fail(function () { return app.alert.error(app.messages.Tender_Details_MsgFailedToSaveNote); })
                    .always(function () { return setTimeout(function () { return $('#saveNote').button('reset'); }, 500); });
            };
            return TenderDetailsNotesViewModel;
        }());
        Tenders.TenderDetailsNotesViewModel = TenderDetailsNotesViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderDetailsSupplierViewModel = (function () {
            function TenderDetailsSupplierViewModel(model) {
                var _this = this;
                this.isChecked = ko.observable(false);
                this.supplierId = model.id;
                this.name = model.name;
                this.email = model.email;
                this.status = model.status;
                this.lastTimeWatched = model.lastTimeWatched;
                this.action = ko.observable(model.action);
                this.isWaiting = ko.computed(function () { return _this.action() === 'Waiting'; });
                this.actionText = ko.computed(function () {
                    switch (_this.action()) {
                        case 'Waiting':
                            return app.messages.Tender_Details_MsgWaiting;
                        case 'Accepted':
                            return app.messages.Tender_Details_MsgAccepted;
                        case 'Rejected':
                            return app.messages.Tender_Details_MsgRejected;
                    }
                    return null;
                });
                this.statusName = ko.computed(function () {
                    switch (_this.status) {
                        case 'Draft':
                            return app.messages.Tender_Details_MsgParticipating;
                        case 'Sent':
                            return app.messages.Tender_Details_MsgBidPlaced;
                        default:
                            {
                                if (_this.lastTimeWatched) {
                                    return app.messages.Tender_Details_MsgReviewed + ' ' + _this.lastTimeWatched;
                                }
                                else {
                                    return null;
                                }
                            }
                    }
                });
                this.statusClass = ko.computed(function () {
                    switch (_this.action()) {
                        case 'Waiting':
                            return 'btn-warning';
                        case 'Accepted':
                            return 'btn-primary';
                        case 'Rejected':
                            return 'btn-danger';
                    }
                    return null;
                });
            }
            return TenderDetailsSupplierViewModel;
        }());
        Tenders.TenderDetailsSupplierViewModel = TenderDetailsSupplierViewModel;
        var TenderDetailsSupplierListViewModel = (function () {
            function TenderDetailsSupplierListViewModel(model) {
                var _this = this;
                this.list = ko.observableArray();
                this.tenderStatus = ko.observable().subscribeTo('TenderStatus', true);
                this.waitingCount = ko.computed(function () { return _this.list().filter(function (item) { return item.isWaiting(); }).length; });
                this.isSelectedAnyCheckBox = ko.computed(function () { return _this.list().some(function (item) { return item.isChecked(); }); });
                this.openInvitationWindow = function () {
                    app.dialog.confirm(app.messages.Tenders.Suppliers_InvitationToParticipateInTender_Header, app.messages.Tenders.Suppliers_InvitationToParticipateInTender_Text)
                        .done(function () { return ko.postbox.publish('msgSendInvitations'); });
                };
                this.changeStatus = function (supplier, status) {
                    var data = { status: status, supplierId: supplier.supplierId };
                    app.http.put('~/api/tendersuppliers/ChangeSupplierStatus?tenderId=' + _this.id, data)
                        .done(function (result) {
                        app.alert.success(app.messages.Tender_Details_MsgStatusChanged);
                        supplier.action(result);
                    })
                        .fail(function () {
                        app.alert.error(app.messages.Tender_Details_MsgStatusNotChanged);
                        supplier.action('Waiting');
                    });
                };
                this.id = model.id;
                this.supplierIds = model.supplierIds;
            }
            TenderDetailsSupplierListViewModel.prototype.load = function () {
                var _this = this;
                app.http.get('~/api/tenderSuppliers', { tenderId: this.id }).done(function (result) {
                    _this.list(result.map(function (item) { return new TenderDetailsSupplierViewModel(item); }));
                    if (_this.tenderStatus() === 'Active' && _this.supplierIds && _this.supplierIds.length) {
                        _this.inviteAddedSuppliers(_this.supplierIds);
                    }
                });
            };
            TenderDetailsSupplierListViewModel.prototype.inviteAddedSuppliers = function (ids) {
                ko.utils.arrayForEach(this.list(), function (supplier) {
                    if (ko.utils.arrayIndexOf(ids, supplier.supplierId) >= 0) {
                        supplier.isChecked(true);
                    }
                });
                this.openInvitationWindow();
            };
            return TenderDetailsSupplierListViewModel;
        }());
        Tenders.TenderDetailsSupplierListViewModel = TenderDetailsSupplierListViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderDetailsThreadViewModel = (function () {
            function TenderDetailsThreadViewModel(model) {
                var _this = this;
                this.sentAt = model.sentAt;
                this.senderName = model.senderName;
                this.threadId = model.threadId;
                this.messageCount = model.messageCount;
                this.text = model.text;
                this.unreadCount = ko.observable(model.unreadCount);
                this.isUnread = ko.computed(function () { return _this.unreadCount() > 0; });
            }
            return TenderDetailsThreadViewModel;
        }());
        Tenders.TenderDetailsThreadViewModel = TenderDetailsThreadViewModel;
        var TenderDetailsThreadListViewModel = (function () {
            function TenderDetailsThreadListViewModel(model) {
                var _this = this;
                this.list = ko.observableArray();
                this.unreadCount = ko.computed(function () { return _this.list().reduce(function (sum, item) { return sum + item.unreadCount(); }, 0); });
                this.openThreadsWindow = function (thread) {
                    _this.messages.load(thread.threadId);
                    $('#threadsWindow').modal('show');
                };
                this.openNewMessageWindow = function () {
                    _this.newMessage.load();
                    $('#newMessageWindow').modal('show');
                };
                this.refresh = function () {
                    _this.list.removeAll();
                    _this.load();
                };
                this.id = model.id;
                this.messages = new app.Messages.MessageListViewModel(model.id, 'tender');
                this.messages.events.subscribe(function () { return _this.refresh(); }, this, 'send');
                this.newMessage = new app.Messages.MessageCreateViewModel(model.id);
                this.newMessage.events.subscribe(function () { return _this.refresh(); }, this, 'saved');
            }
            TenderDetailsThreadListViewModel.prototype.load = function () {
                var _this = this;
                app.http.get('~/api/threads', { tenderId: this.id, isBider: false })
                    .done(function (result) { return _this.list(result.map(function (item) { return new TenderDetailsThreadViewModel(item); })); })
                    .fail(app.handleErrors);
            };
            return TenderDetailsThreadListViewModel;
        }());
        Tenders.TenderDetailsThreadListViewModel = TenderDetailsThreadListViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var msgSendReminders = 'msgSendReminders';
        var msgSendInvitations = 'msgSendInvitations';
        var TenderDetailsViewModel = (function () {
            function TenderDetailsViewModel(model) {
                var _this = this;
                this.status = ko.observable().publishOn('TenderStatus');
                this.isArchived = ko.observable();
                this.endDate = ko.observable().extend({ date: true });
                this.endTime = ko.computed(this.endDate).extend({ time: true });
                this.name = ko.observable();
                this.css = ko.observable();
                this.visible = ko.computed(function () { return true; });
                this.canEditOrPublish = ko.computed(function () { return _this.status() === 'Draft' || _this.status() === 'Suspend'; });
                this.canClose = ko.computed(function () { return _this.status() === 'Active'; });
                this.canSuspend = ko.computed(function () { return _this.status() === 'Active'; });
                this.canExtendEndDate = ko.computed(function () { return _this.status() === 'Active'; });
                this.canArchive = ko.computed(function () { return _this.status() === 'Closed' && !_this.isArchived(); });
                this.canUnarchive = ko.computed(function () { return _this.isArchived(); });
                this.canDeleteTender = ko.computed(function () { return _this.status() === 'Draft'; });
                this.projectId = ko.observable();
                this.projectIdOptions = ko.observableArray();
                this.ownerId = ko.observable();
                this.ownerIdOptions = ko.observableArray();
                this.itemList = ko.observableArray();
                this.groupedList = ko.observableArray();
                this.questionList = ko.observableArray();
                this.documentList = ko.observableArray();
                this.getDocument = ko.observable();
                this.projectChanged = function () {
                    app.http.postInteractive("~/api/tenders/updatefolder?tenderId=" + _this.id, _this.projectId()).fail(function () {
                        app.alert.error(app.messages.Tender_Details_MsgUpdateFolderFaild);
                    });
                };
                this.ownerChanged = function () {
                    if (_this.ownerId()) {
                        app.http.postInteractive("~/api/tenders/updateowner?tenderId=" + _this.id, _this.ownerId()).fail(function () {
                            app.alert.error(app.messages.Tender_Details_MsgUpdateOwnerFaild);
                        });
                    }
                };
                this.archive = function () {
                    app.http.put("~/api/tenders/changeArchiveStatus?tenderId=" + _this.id, true).done(function (result) {
                        _this.isArchived(result);
                        app.alert.info(app.messages.Tender_Details_MsgTenderArchived);
                    });
                };
                this.unarchive = function () {
                    app.http.put("~/api/tenders/changeArchiveStatus?tenderId=" + _this.id, false).done(function (result) {
                        _this.isArchived(result);
                        app.alert.info(app.messages.Tender_Details_MsgTenderUnArchived);
                    });
                };
                this.questionDisplayMode = function (item) {
                    switch (item.type) {
                        case 'SingleChoice':
                            return 'singleChoice';
                        case 'MultiChoice':
                            return 'multiChoice';
                        case 'SingleLineText':
                            return 'singleLineText';
                        case 'MultiLineText':
                            return 'multiLineText';
                        case 'Upload':
                            return 'upload';
                        case 'YesNo':
                            return 'yesNo';
                    }
                    throw app.messages.Tender_Details_MsgTypeNotFound;
                };
                this.commentBoxDisplayMode = function (item) { return item.commentEnabled ? 'commentBox' : null; };
                this.openPublishWindow = function () {
                    app.dialog.confirm(app.messages.Tenders.PublishTender, app.messages.Tenders.PublishTender).done(function () {
                        app.http.putInteractive("~/api/tenders/publish?tenderId=" + _this.id).done(function () {
                            _this.status('Active');
                            _this.name(null);
                            _this.css(null);
                            //this.pageTag.hide();
                            app.alert.info(app.messages.Tender_Details_MsgTenderPublished);
                        });
                    });
                };
                this.openSuspendWindow = function () {
                    app.dialog.confirm(app.messages.Tenders.SuspendTender, app.messages.Tenders.MsgParticipantsWillHaveToResubmitBids).done(function () {
                        app.http.putInteractive("~/api/tenders/suspendTender?tenderId=" + _this.id).done(function () {
                            _this.status('Suspend');
                            _this.name(app.messages.Tag_MsgSuspended);
                            _this.css('label-warning');
                            //this.pageTag.show('label-warning', app.messages.Tag_MsgSuspended);
                            app.alert.info(app.messages.Tender_Details_MsgTenderSuspended);
                        });
                    });
                };
                this.openExtendEndDateWindow = function () {
                    angular.element(document).injector().invoke([
                        'extendTenderService', '$filter', function (extendTenderService, $filter) {
                            extendTenderService.showDialog()
                                .then(function (model) { return extendTenderService.extendEndDate(_this.id, model); })
                                .then(function (extendedTo) { return _this.endDate.value(extendedTo); })
                                .then(function () { return app.alert.info(app.messages.Tender_Details_MsgTenderTimeExtended); });
                        }
                    ]);
                };
                this.copyTender = function () {
                    app.redirect("/tenders/create/" + _this.id);
                };
                this.deleteTender = function () {
                    app.dialog.confirmRemove().done(function () { return app.http.delete('~/api/tenders', _this.id).done(function () { return app.redirect('~/#/buyer/tenders'); }); });
                };
                this.id = model.id;
                this.status(model.status);
                this.isArchived(model.isArchived);
                this.endDate(model.endDate);
                if (model.pageTag != null) {
                    this.name(model.pageTag.name);
                    this.css(model.pageTag.css);
                }
                else {
                    this.name(null);
                    this.css(null);
                }
                //this.pageTag = new PageTag(model.pageTag);
                this.suppliers = new Tenders.TenderDetailsSupplierListViewModel(model);
                this.threads = new Tenders.TenderDetailsThreadListViewModel(model);
                this.bids = new Tenders.TenderDetailsBidListViewModel(model);
                this.notes = new Tenders.TenderDetailsNotesViewModel(model);
                this.projectId(model.projectId);
                this.projectId.subscribe(function () { return _this.projectChanged(); });
                this.ownerId(model.ownerId);
                this.ownerId.subscribe(function () { return _this.ownerChanged(); });
                //this.groupedList([]);
                ko.postbox.subscribe(msgSendReminders, function () { return _this.sendRemind(); });
                ko.postbox.subscribe(msgSendInvitations, function () { return _this.sendInvitation(); });
            }
            TenderDetailsViewModel.prototype.init = function (element) {
                var requests = [
                    app.datasource.tenderFolders(false).done(this.projectIdOptions),
                    app.datasource.users().done(this.ownerIdOptions)
                ];
                app.applyBindingsWhenDone(requests, this, element);
                this.loadItems();
                var hash = window.location.hash;
                if (hash && (hash.substr(0, 4) === '#tab')) {
                    $("#tabs a[href=" + hash + "]").tab('show');
                }
            };
            TenderDetailsViewModel.prototype.sendRemind = function () {
                var selectedBids = this.bids.list().filter(function (item) { return item.isChecked(); });
                var selectedBidIds = selectedBids.map(function (item) { return item.id; });
                app.http.putInteractive('~/api/tenders/sendReminder', selectedBidIds).done(function () {
                    app.alert.info(app.messages.Tender_Bids_SendReminder);
                });
            };
            TenderDetailsViewModel.prototype.sendInvitation = function () {
                var selectedSuppliers = this.suppliers.list().filter(function (item) { return item.isChecked(); });
                var selectedSupplierIds = selectedSuppliers.map(function (item) { return item.supplierId; });
                app.http.putInteractive('~/api/tenderSuppliers/sendInvitations?tenderId=' + this.id, selectedSupplierIds).done(function () {
                    app.alert.info(app.messages.Tender_Suppliers_SendInvitation);
                });
            };
            TenderDetailsViewModel.prototype.loadItems = function () {
                var _this = this;
                app.http.get('~/api/tenderItems', { tenderId: this.id })
                    .then(function (result) { _this.itemList(result.map(_this.itemlistMap)); })
                    .then(function () { return _this.groupedList(_this.groupItemList()); });
                app.http.get('~/api/tenderDocuments', { tenderId: this.id }).done(function (result) {
                    _this.documentList(ko.utils.arrayMap(result, _this.documentListMap));
                });
                app.http.get('~/api/tenderQuestions', { tenderId: this.id }).done(function (result) {
                    _this.questionList(ko.utils.arrayMap(result, _this.questionListMap));
                });
                this.suppliers.load();
                this.threads.load();
                this.bids.load();
            };
            TenderDetailsViewModel.prototype.itemlistMap = function (item) {
                return new Tenders.TenderItemViewModel(item);
            };
            TenderDetailsViewModel.prototype.documentListMap = function (item) {
                var result = ko.utils.extend({}, item);
                return ko.utils.extend(result, {
                    url: app.clientUrl('~/api/tenderDocuments/' + item.id)
                });
            };
            TenderDetailsViewModel.prototype.questionListMap = function (item) {
                var result = ko.utils.extend({}, item);
                return ko.utils.extend(result, {
                    questionText: item.seq + '. ' + item.questionText,
                    url: app.clientUrl('~/api/tenderQuestions/' + item.id)
                });
            };
            TenderDetailsViewModel.prototype.groupItemList = function () {
                var index = {}, group = [];
                ko.utils.arrayForEach(this.itemList(), function (ti) {
                    var itemGroup = ko.unwrap(ti.group) || '';
                    if (!index.hasOwnProperty(itemGroup)) {
                        index[itemGroup] = new Tenders.TenderDetailsGroupItemViewModel(itemGroup, []);
                        group.push(index[itemGroup]);
                    }
                    index[itemGroup].items.push(ti);
                });
                return group.sort(function (a, b) { return a.name.localeCompare(b.name); });
            };
            return TenderDetailsViewModel;
        }());
        Tenders.TenderDetailsViewModel = TenderDetailsViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderDocumentViewModel = (function () {
            function TenderDocumentViewModel(data) {
                this.latestData = null;
                this.selected = ko.observable(false);
                this.editing = ko.observable(false);
                this.name = ko.observable();
                this.description = ko.observable();
                this.size = ko.observable();
                this.id = data.id;
                this.update(data);
            }
            TenderDocumentViewModel.prototype.edit = function () {
                this.editing(true);
            };
            TenderDocumentViewModel.prototype.done = function () {
                this.editing(false);
                this.latestData = { name: this.name(), description: this.description(), size: this.size() };
            };
            TenderDocumentViewModel.prototype.cancel = function () {
                this.update(this.latestData);
                this.editing(false);
            };
            TenderDocumentViewModel.prototype.update = function (data) {
                this.name(data.name);
                this.description(data.description);
                this.size(data.size);
                this.latestData = data;
            };
            return TenderDocumentViewModel;
        }());
        Tenders.TenderDocumentViewModel = TenderDocumentViewModel;
        var TenderEditDocumentsViewModel = (function () {
            function TenderEditDocumentsViewModel(tenderId) {
                var _this = this;
                this.list = ko.observableArray();
                this.editing = ko.computed(function () { return _this.list().filter(function (document) { return document.editing(); }); });
                this.selected = ko.computed(function () { return _this.list().filter(function (document) { return document.selected(); }); });
                this.deleteSelected = function () {
                    _this.list.removeAll(_this.selected());
                };
                this.addDocument = function () {
                    $('#documentFileUpload').trigger('click');
                };
                this.cancelEdit = function (document) {
                    if (document.id === 0) {
                        _this.list.remove(document);
                    }
                    else {
                        document.cancel();
                    }
                };
                this.id = tenderId;
            }
            TenderEditDocumentsViewModel.prototype.init = function () {
                var _this = this;
                this.refresh();
                $('#documentFileUpload').fileupload({
                    dataType: 'json',
                    send: function () {
                        var button = $('#documentUploadDocument');
                        button.prop('disabled', true).attr('data-original-text', button.html()).html('0 %');
                    },
                    done: function (e, data) {
                        var document = _this.documentMap(data.result);
                        _this.list.push(document);
                        document.edit();
                        $('#documents #name:last').focus();
                    },
                    fail: function (e, data) {
                        app.handleErrors(data.jqXHR, app.messages.Tender_Documents_MsgFailedToUploadDocument);
                    },
                    always: function () {
                        var button = $('#documentUploadDocument');
                        button.prop('disabled', false).html(button.attr('data-original-text'));
                    },
                    progressall: function (e, data) {
                        var progress = Math.round(data.loaded / data.total * 100);
                        $('#documentUploadDocument').html(progress + " %");
                    }
                });
            };
            TenderEditDocumentsViewModel.prototype.displayMode = function (document) {
                return document.editing() ? 'documentEdit' : 'documentDisplay';
            };
            TenderEditDocumentsViewModel.prototype.refresh = function () {
                var _this = this;
                return app.http.get('~/api/tenderDocuments?tenderId=' + this.id).done(function (result) {
                    _this.list(ko.utils.arrayMap(result, _this.documentMap));
                });
            };
            TenderEditDocumentsViewModel.prototype.documentMap = function (item) {
                return new TenderDocumentViewModel(item);
            };
            return TenderEditDocumentsViewModel;
        }());
        Tenders.TenderEditDocumentsViewModel = TenderEditDocumentsViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var ImportWindowModel = (function () {
            function ImportWindowModel() {
                this.imported = ko.observable(0);
                this.skipped = ko.observable(0);
                this.errors = ko.observableArray();
            }
            ImportWindowModel.prototype.show = function (data) {
                this.imported(data.imported);
                this.skipped(data.skipped);
                this.errors(data.errors);
                $('#importResultWindow').modal({ show: true });
            };
            return ImportWindowModel;
        }());
        Tenders.ImportWindowModel = ImportWindowModel;
        var TenderGroupItemCollapsedViewModel = (function () {
            function TenderGroupItemCollapsedViewModel(name, value) {
                this.value = ko.observable();
                this.key = name;
                this.value(true);
            }
            return TenderGroupItemCollapsedViewModel;
        }());
        Tenders.TenderGroupItemCollapsedViewModel = TenderGroupItemCollapsedViewModel;
        var TenderDetailsGroupItemViewModel = (function () {
            function TenderDetailsGroupItemViewModel(name, items) {
                var _this = this;
                this.isCollapsed = ko.observable();
                this.items = ko.observableArray();
                this.collapse = function (state) { _this.isCollapsed(!state.isCollapsed()); };
                this.name = name;
                this.isCollapsed(true);
                this.items(items);
            }
            return TenderDetailsGroupItemViewModel;
        }());
        Tenders.TenderDetailsGroupItemViewModel = TenderDetailsGroupItemViewModel;
        var TenderGroupItemViewModel = (function () {
            function TenderGroupItemViewModel(name, items) {
                this.items = ko.observableArray();
                this.name = name;
                this.items(items);
            }
            return TenderGroupItemViewModel;
        }());
        Tenders.TenderGroupItemViewModel = TenderGroupItemViewModel;
        var TenderItemViewModel = (function () {
            function TenderItemViewModel(model) {
                var _this = this;
                this.latestData = null;
                this.id = ko.observable();
                this.selected = ko.observable(false);
                this.editing = ko.observable(false);
                this.seq = ko.observable().extend({ number: { format: 'd' } });
                this.name = ko.observable();
                this.description = ko.observable();
                this.quantity = ko.observable().extend({ number: true });
                this.units = ko.observable();
                this.group = ko.observable();
                this.edit = function () {
                    _this.editing(true);
                };
                this.done = function (result) {
                    _this.id(result);
                    _this.editing(false);
                    _this.latestData = {
                        seq: _this.seq(),
                        name: _this.name(),
                        description: _this.description(),
                        quantity: _this.quantity(),
                        units: _this.units(),
                        group: _this.group()
                    };
                    ko.postbox.publish('tender.item.saved', _this);
                };
                this.cancel = function () {
                    _this.update(_this.latestData);
                    _this.editing(false);
                };
                this.id(model.id);
                this.seq(model.seq);
                this.selected.subscribe(function () { return ko.postbox.publish('itemSelectedChanged'); });
                this.update(model);
            }
            TenderItemViewModel.prototype.toJS = function () {
                return {
                    id: this.id(),
                    name: this.name(),
                    description: this.description(),
                    quantity: this.quantity(),
                    units: this.units(),
                    seq: this.seq(),
                    group: this.group()
                };
            };
            TenderItemViewModel.prototype.update = function (data) {
                this.seq(data.seq);
                this.name(data.name);
                this.description(data.description);
                this.quantity(data.quantity);
                this.units(data.units);
                this.group(data.group);
                this.latestData = data;
            };
            return TenderItemViewModel;
        }());
        Tenders.TenderItemViewModel = TenderItemViewModel;
        var TenderEditItemsViewModel = (function () {
            function TenderEditItemsViewModel(tenderId) {
                var _this = this;
                this.itemSelectedChanging = false;
                this.list = ko.observableArray();
                this.groupedList = ko.observableArray();
                this.collapsedList = ko.observableArray();
                this.selected = ko.computed(function () { return _this.list().filter(function (item) { return item.selected(); }); });
                this.selectedAll = ko.observable(false);
                this.editing = ko.computed(function () { return _this.list().filter(function (item) { return item.editing(); }); });
                this.importWindow = new ImportWindowModel();
                this.addDocument = function () {
                    $('#importFileUpload').trigger('click');
                };
                this.deleteSelected = function () {
                    _this.list.removeAll(_this.selected());
                    _this.groupedList(_this.groupList());
                };
                this.addItem = function () {
                    var item = _this.listMap({ id: 0, seq: _this.getNextSeq(), group: '' });
                    item.edit();
                    _this.list.push(item);
                    _this.groupedList(_this.groupList());
                    $('#items #name:last()').focus();
                };
                this.cancelEdit = function (item) {
                    if (item.id() === 0) {
                        _this.list.remove(item);
                    }
                    else {
                        item.cancel();
                    }
                    _this.groupedList(_this.groupList());
                };
                this.selectAllItems = function (value) {
                    if (_this.itemSelectedChanging)
                        return;
                    _this.itemSelectedChanging = true;
                    _this.list().forEach(function (item) { return item.selected(value); });
                    _this.itemSelectedChanging = false;
                };
                this.displayMode = function (item) {
                    return item.editing() ? 'itemEdit' : 'itemDisplay';
                };
                this.onCollapse = function (group) {
                    var name = typeof group === 'string' ? group : group.name;
                    var index = _this.collapsedList().map(function (e) { return e.key; }).indexOf(name);
                    _this.collapsedList()[index].value(!_this.collapsedList()[index].value());
                };
                this.isCollapsed = function (groupName) {
                    var index = _this.collapsedList().map(function (e) { return e.key; }).indexOf(groupName);
                    if (index == -1) {
                        _this.collapsedList().push(new TenderGroupItemCollapsedViewModel(groupName, true));
                        return true;
                    }
                    return _this.collapsedList()[index].value();
                };
                this.id = tenderId;
                this.selectedAll.subscribe(function (value) { return _this.selectAllItems(value); });
            }
            TenderEditItemsViewModel.prototype.init = function () {
                var _this = this;
                this.load();
                ko.postbox.subscribe('itemSelectedChanged', function () {
                    if (_this.itemSelectedChanging)
                        return;
                    _this.itemSelectedChanging = true;
                    var result = _this.list().every(function (item) { return item.selected(); });
                    _this.selectedAll(result);
                    _this.itemSelectedChanging = false;
                });
                ko.postbox.subscribe('tender.item.saved', function (item) {
                    var list = _this.groupList();
                    var group = item.group();
                    if (group && _this.isCollapsed(group)) {
                        _this.onCollapse(group);
                    }
                    _this.groupedList(list);
                });
                $('#importFileUpload').fileupload({
                    dataType: 'json',
                    send: function () {
                        var button = $('#importUploadDocument');
                        button.prop('disabled', true).attr('data-original-text', button.html()).html('0 %');
                    },
                    done: function (e, data) {
                        data.result.list.forEach(function (item) { return _this.list.push(_this.listMap(item)); });
                        _this.groupedList(_this.groupList());
                        _this.importWindow.show(data.result);
                    },
                    fail: function () {
                        app.alert.error(app.messages.Tender_Documents_MsgFailedToUploadDocument);
                    },
                    always: function () {
                        var button = $('#importUploadDocument');
                        button.prop('disabled', false).html(button.attr('data-original-text'));
                    },
                    progressall: function (e, data) {
                        var progress = Math.round(data.loaded / data.total * 100);
                        $('#importUploadDocument').html('' + progress + ' %');
                    }
                });
            };
            TenderEditItemsViewModel.prototype.toJS = function () {
                return { list: app.mapping.toJS(this.list()) };
            };
            TenderEditItemsViewModel.prototype.load = function () {
                var _this = this;
                app.http.get('~/api/tenderItems?tenderId=' + this.id)
                    .then(function (result) { return _this.list(result.map(_this.listMap)); })
                    .then(function () { return _this.groupedList(_this.groupList()); })
                    .then(function () {
                    var self = _this;
                    ko.utils.arrayForEach(_this.groupedList(), function (group) {
                        self.collapsedList().push(new TenderGroupItemCollapsedViewModel(group.name, false));
                    });
                });
            };
            TenderEditItemsViewModel.prototype.listMap = function (item) {
                return new TenderItemViewModel(item);
            };
            TenderEditItemsViewModel.prototype.getNextSeq = function () {
                var items = this.list();
                if (items.length === 0) {
                    return 1;
                }
                var maxSeq = items[0].seq();
                for (var i = 1; i < items.length; i++) {
                    if (items[i].seq() > maxSeq) {
                        maxSeq = items[i].seq();
                    }
                }
                return maxSeq + 1;
            };
            TenderEditItemsViewModel.prototype.groupList = function () {
                var index = {}, group = [];
                ko.utils.arrayForEach(this.list(), function (ti) {
                    var itemGroup = ko.unwrap(ti.group) || '';
                    if (!index.hasOwnProperty(itemGroup)) {
                        index[itemGroup] = new TenderGroupItemViewModel(itemGroup, []);
                        group.push(index[itemGroup]);
                    }
                    index[itemGroup].items.push(ti);
                });
                return group.sort(function (a, b) { return a.name.localeCompare(b.name); });
            };
            return TenderEditItemsViewModel;
        }());
        Tenders.TenderEditItemsViewModel = TenderEditItemsViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderQuestionViewModel = (function () {
            function TenderQuestionViewModel(model) {
                var _this = this;
                this.latestData = null;
                this.id = ko.observable();
                this.seq = ko.observable().extend({ number: { format: 'd' } });
                this.selected = ko.observable();
                this.editing = ko.observable();
                this.questionText = ko.observable();
                this.type = ko.observable();
                this.commentEnabled = ko.observable();
                this.required = ko.observable();
                this.choices = ko.observableArray();
                this.typeOptions = ko.observable().subscribeTo('questionTypeOptions', true);
                this.edit = function () {
                    _this.editing(true);
                    $('[name=questionText]:last').focus();
                };
                this.done = function (result) {
                    _this.id(result);
                    _this.editing(false);
                    _this.latestData = {
                        questionText: _this.questionText(),
                        type: _this.type(),
                        choices: ko.utils.arrayMap(_this.choices(), function (item) { return item.value(); }),
                        commentEnabled: _this.commentEnabled(),
                        required: _this.required()
                    };
                };
                this.cancel = function () {
                    _this.update(_this.latestData);
                    _this.editing(false);
                };
                this.addChoice = function () {
                    _this.choices.push({ value: ko.observable() });
                };
                this.removeChoice = function () {
                    _this.choices.pop();
                };
                this.displayMode = function () {
                    if (_this.editing()) {
                        switch (_this.type()) {
                            case 'SingleChoice':
                            case 'MultiChoice':
                                return 'singleMultiChoiceEdit';
                            case 'SingleLineText':
                                return 'singleLineTextEdit';
                            case 'MultiLineText':
                                return 'multiLineTextEdit';
                            case 'Upload':
                                return 'uploadEdit';
                            case 'YesNo':
                                return 'yesNoEdit';
                        }
                    }
                    else {
                        switch (_this.type()) {
                            case 'SingleChoice':
                                return 'singleChoice';
                            case 'MultiChoice':
                                return 'multiChoice';
                            case 'SingleLineText':
                                return 'singleLineText';
                            case 'MultiLineText':
                                return 'multiLineText';
                            case 'Upload':
                                return 'upload';
                            case 'YesNo':
                                return 'yesNo';
                        }
                    }
                    return 'Unknown';
                };
                this.id(model.id);
                this.seq(model.seq);
                this.update(model);
            }
            TenderQuestionViewModel.prototype.toJS = function () {
                var data = ko.toJS(this);
                data.choices = ko.utils.arrayMap(this.choices(), function (item) { return item.value(); });
                return data;
            };
            TenderQuestionViewModel.prototype.update = function (data) {
                this.questionText(data.questionText);
                this.type(data.type);
                this.choices(ko.utils.arrayMap(data.choices, function (item) { return ({ value: ko.observable(item) }); }));
                this.commentEnabled(data.commentEnabled);
                this.required(data.required);
                this.latestData = data;
            };
            return TenderQuestionViewModel;
        }());
        Tenders.TenderQuestionViewModel = TenderQuestionViewModel;
        var TenderEditQuestionsViewModel = (function () {
            function TenderEditQuestionsViewModel(id) {
                var _this = this;
                this.id = id;
                this.questionTypeOptions = ko.observableArray().publishOn('questionTypeOptions');
                this.list = ko.observableArray();
                this.editing = ko.computed(function () { return _this.list().filter(function (question) { return question.editing(); }); });
                this.selected = ko.computed(function () { return _this.list().filter(function (question) { return question.selected(); }); });
                this.deleteSelected = function () {
                    _this.list.removeAll(_this.selected());
                };
                this.addQuestion = function () {
                    var question = _this.listMap({ id: 0, type: 'SingleChoice', choices: ['', ''], seq: _this.getNextSeq() });
                    question.edit();
                    _this.list.push(question);
                    $('[name=questionText]:last').focus();
                };
                this.cancelEdit = function (question) {
                    if (question.id() === 0) {
                        _this.list.remove(question);
                    }
                    else {
                        question.cancel();
                    }
                };
                this.displayMode = function (question) { return question.editing() ? 'questionEdit' : 'questionDisplay'; };
            }
            TenderEditQuestionsViewModel.prototype.init = function () {
                var _this = this;
                app.http.get('~/api/tenderQuestions?tenderId=' + this.id).done(function (result) {
                    _this.list(ko.utils.arrayMap(result, _this.listMap));
                });
            };
            TenderEditQuestionsViewModel.prototype.getNextSeq = function () {
                var list = this.list();
                var lastItem = list[list.length - 1];
                return lastItem ? lastItem.seq() + 1 : 1;
            };
            TenderEditQuestionsViewModel.prototype.listMap = function (item) {
                return new TenderQuestionViewModel(item);
            };
            return TenderEditQuestionsViewModel;
        }());
        Tenders.TenderEditQuestionsViewModel = TenderEditQuestionsViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var SearchSupplierViewModel = (function () {
            function SearchSupplierViewModel(model) {
                var _this = this;
                this.id = ko.observable();
                this.buttonText = ko.computed(function () { return _this.id() !== null ? app.messages.Tender_SearchSuppliers_RemoveSupplier : app.messages.Tender_SearchSuppliers_AddSupplier; });
                this.emailSource = function () {
                    function formatContact(contact) {
                        var title = contact.title ? ", " + contact.title : '';
                        var mailSeparator = contact.name || contact.title ? ', ' : '';
                        return contact.email + "#" + contact.email + mailSeparator + contact.name + title;
                    }
                    return app.http.get("~/api/contacts/autocomplete", { partyId: _this.partyId, organizationId: _this.organizationId })
                        .then(function (response) { return response.map(formatContact); });
                };
                this.id(model.id);
                this.organizationId = model.organizationId;
                this.partyId = model.partyId;
                this.name = model.name;
                this.address = model.country !== null && model.city !== null ? model.country + ', ' + model.city : model.country != null ? model.country : model.city;
                this.email = model.email;
                this.url = this.getUrl();
            }
            SearchSupplierViewModel.prototype.getUrl = function () {
                return this.partyId != null ? app.clientUrl("~/#/partners/details?id=" + this.partyId) :
                    this.organizationId != null ? app.clientUrl("~/#/partners/organization/" + this.organizationId) : null;
            };
            return SearchSupplierViewModel;
        }());
        Tenders.SearchSupplierViewModel = SearchSupplierViewModel;
        var SearchSuppliersViewModel = (function () {
            function SearchSuppliersViewModel(tenderId) {
                var _this = this;
                this.tenderId = tenderId;
                this.invitedSupplierIds = [];
                this.list = ko.observableArray();
                this.filter = new PartnersListFilterViewModel();
                this.changeSupplier = function (supplier) {
                    if (supplier.id() !== null) {
                        app.http.postInteractive('~/api/tenderSearchSuppliers/remove', supplier.id()).done(function () {
                            var index = ko.utils.arrayIndexOf(_this.invitedSupplierIds, supplier.id());
                            if (index > -1) {
                                _this.invitedSupplierIds.splice(index, 1);
                            }
                            supplier.id(null);
                            if (supplier.partyId == null && supplier.organizationId == null) {
                                _this.list.remove(supplier);
                            }
                        });
                    }
                    else {
                        if (!supplier.email) {
                            app.alert.error(app.messages.Tenders.Suppliers_MsgEmailMissing);
                            return;
                        }
                        var data = { partyId: supplier.partyId, organizationId: supplier.organizationId, email: supplier.email };
                        app.http.postInteractive("~/api/tenderSearchSuppliers/assign?tenderId=" + _this.tenderId, data).done(function (response) {
                            supplier.id(response);
                            _this.invitedSupplierIds.push(response);
                        });
                    }
                };
                this.addSupplierByEmail = {
                    email: ko.observable(),
                    done: function () {
                        if (_this.addSupplierByEmail.email() !== undefined)
                            app.http.post("~/api/tenderSearchSuppliers?tenderId=" + _this.tenderId, _this.addSupplierByEmail.email()).done(function (id) {
                                _this.invitedSupplierIds.push(id);
                                _this.filter.clear();
                                _this.refresh();
                            });
                        _this.addSupplierByEmail.email('');
                    }
                };
                ko.postbox.subscribe('filterChanged', function () { return _this.refresh(); });
            }
            SearchSuppliersViewModel.prototype.init = function () {
                this.filter.load();
                this.refresh();
            };
            SearchSuppliersViewModel.prototype.refresh = function () {
                var _this = this;
                var data = this.filter.toJS();
                app.http.getInteractive("~/api/tenderSearchSuppliers?id=" + this.tenderId, data).done(function (result) {
                    _this.list(result.data.map(function (item) { return new SearchSupplierViewModel(item); }));
                    _this.filter.totalCount(result.totalCount);
                    ko.postbox.publish('listViewLoaded', true);
                });
            };
            // TODO: Cia kazkodel buvo taip padaryta
            SearchSuppliersViewModel.prototype.getInvitedSupplierIds = function () {
                return this.invitedSupplierIds;
            };
            return SearchSuppliersViewModel;
        }());
        Tenders.SearchSuppliersViewModel = SearchSuppliersViewModel;
        var PartnersListFilterViewModel = (function () {
            function PartnersListFilterViewModel() {
                var _this = this;
                this.assignedOnly = ko.observable();
                this.isPartner = ko.observable();
                this.selectedCountry = ko.observable();
                this.selectedFolder = ko.observable();
                this.name = ko.observable('');
                this.category = ko.observable('');
                this.categoryText = ko.observable();
                this.countries = ko.observableArray();
                this.folders = ko.observableArray();
                this.pageIndex = ko.observable(1);
                this.totalCount = ko.observable(0);
                this.categorySource = function (query) { return app.http.get('~/api/cpvs/lookup', { query: query }); };
                this.submit = function () {
                    _this.pageIndex(1);
                    _this.filterChanged();
                };
                this.clear = function () {
                    _this.name('');
                    _this.assignedOnly(false);
                    _this.isPartner(false);
                    _this.category('');
                    _this.categoryText('');
                    _this.selectedCountry(null);
                    _this.selectedFolder(null);
                    _this.pageIndex(1);
                    _this.filterChanged();
                };
                ko.postbox.subscribe('pageChanged', function () {
                    $('html,body').scrollTop(0);
                    _this.filterChanged();
                });
            }
            PartnersListFilterViewModel.prototype.load = function () {
                // TODO: applyBindingThenDone gal?
                app.datasource.countries().done(this.countries);
                app.datasource.partnerFolders(false).done(this.folders);
            };
            PartnersListFilterViewModel.prototype.toJS = function () {
                return {
                    assignedOnly: this.assignedOnly(),
                    name: this.name(),
                    isPartner: this.isPartner(),
                    category: this.category(),
                    country: this.selectedCountry(),
                    folder: this.selectedFolder(),
                    pageIndex: this.pageIndex()
                };
            };
            PartnersListFilterViewModel.prototype.filterChanged = function () {
                ko.postbox.publish('filterChanged');
            };
            return PartnersListFilterViewModel;
        }());
        Tenders.PartnersListFilterViewModel = PartnersListFilterViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Tenders;
    (function (Tenders) {
        'use strict';
        var TenderEditViewModel = (function () {
            function TenderEditViewModel(model) {
                var _this = this;
                this.css = '';
                this.visible = false;
                this.id = ko.observable();
                this.categorySource = function (query) { return app.http.get('~/api/cpvs/lookup', { query: query }); };
                this.plannedStartDate = ko.observable().extend({ date: true });
                this.plannedStartTime = ko.observable().extend({ time: true });
                this.endDate = ko.observable().extend({ date: true });
                this.endTime = ko.observable().extend({ time: true });
                this.projectId = ko.observable();
                this.projectIdOptions = ko.observableArray();
                this.ownerIdOptions = ko.observableArray();
                this.currencyIdOptions = ko.observableArray();
                this.publicityOptions = ko.observableArray();
                this.canSave = ko.pureComputed(function () { return !_this.items.editing().length && !_this.questions.editing().length && !_this.documents.editing().length; });
                this.showNewProjectName = ko.computed(function () { return _this.projectId() === 0; });
                this.save = function () {
                    $('#editForm').submit();
                };
                this.cancel = function () {
                    app.redirect('~/tenders/details/' + _this.id());
                };
                this.items = new app.Tenders.TenderEditItemsViewModel(model.id);
                this.questions = new app.Tenders.TenderEditQuestionsViewModel(model.id);
                this.documents = new app.Tenders.TenderEditDocumentsViewModel(model.id);
                this.searchSuppliers = new app.Tenders.SearchSuppliersViewModel(model.id);
                app.mapping.fromJS(model, this);
            }
            TenderEditViewModel.prototype.init = function (element) {
                var _this = this;
                var requests = [
                    app.datasource.tenderFolders(true).done(this.projectIdOptions),
                    app.datasource.users().done(this.ownerIdOptions),
                    app.datasource.currencies().done(this.currencyIdOptions)
                ];
                app.applyBindingsWhenDone(requests, this, element).done(function () {
                    _this.items.init();
                    _this.questions.init();
                    _this.documents.init();
                    _this.searchSuppliers.init();
                });
            };
            TenderEditViewModel.prototype.done = function () {
                app.redirect('~/tenders/details/' + this.id());
            };
            return TenderEditViewModel;
        }());
        Tenders.TenderEditViewModel = TenderEditViewModel;
    })(Tenders = app.Tenders || (app.Tenders = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Users;
    (function (Users) {
        'use strict';
        var UserEditViewModel = (function () {
            function UserEditViewModel(model) {
                this.css = '';
                this.visible = false;
                this.departmentIdOptions = ko.observableArray();
                this.firstApproverIdOptions = ko.observableArray();
                this.firstApproverLimit = ko.observable().extend({ number: true });
                this.secondApproverIdOptions = ko.observableArray();
                this.permissions = new app.Shared.PermissionsModel();
                app.mapping.fromJS(model, this);
            }
            UserEditViewModel.prototype.init = function (element) {
                var _this = this;
                var requests = [
                    app.datasource.users().done(function (response) {
                        _this.firstApproverIdOptions(response);
                        _this.secondApproverIdOptions(response);
                    }),
                    app.datasource.departments().done(function (response) {
                        _this.departmentIdOptions(response);
                    })
                ];
                app.applyBindingsWhenDone(requests, this, element);
            };
            UserEditViewModel.prototype.done = function () {
                app.redirect('~/#/users');
            };
            return UserEditViewModel;
        }());
        Users.UserEditViewModel = UserEditViewModel;
    })(Users = app.Users || (app.Users = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Sys;
    (function (Sys) {
        var Organizations;
        (function (Organizations) {
            'use strict';
            var OrganizationDetailsCustomBarcodeViewModel = (function () {
                function OrganizationDetailsCustomBarcodeViewModel() {
                    this.enabled = ko.observable();
                }
                OrganizationDetailsCustomBarcodeViewModel.prototype.done = function () {
                    app.alert.success('Settings updated.');
                };
                return OrganizationDetailsCustomBarcodeViewModel;
            }());
            Organizations.OrganizationDetailsCustomBarcodeViewModel = OrganizationDetailsCustomBarcodeViewModel;
        })(Organizations = Sys.Organizations || (Sys.Organizations = {}));
    })(Sys = app.Sys || (app.Sys = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Sys;
    (function (Sys) {
        var Organizations;
        (function (Organizations) {
            'use strict';
            var OrganizationCustomOrganizationSettingsViewModel = (function () {
                function OrganizationCustomOrganizationSettingsViewModel() {
                    this.isPurchaseImportEnabled = ko.observable();
                }
                OrganizationCustomOrganizationSettingsViewModel.prototype.done = function () {
                    app.alert.success('Settings updated.');
                };
                return OrganizationCustomOrganizationSettingsViewModel;
            }());
            Organizations.OrganizationCustomOrganizationSettingsViewModel = OrganizationCustomOrganizationSettingsViewModel;
        })(Organizations = Sys.Organizations || (Sys.Organizations = {}));
    })(Sys = app.Sys || (app.Sys = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Sys;
    (function (Sys) {
        var Organizations;
        (function (Organizations) {
            'use strict';
            var OrganizationDetailsESaskaitaViewModel = (function () {
                function OrganizationDetailsESaskaitaViewModel() {
                    this.enabled = ko.observable();
                }
                OrganizationDetailsESaskaitaViewModel.prototype.done = function () {
                    app.alert.success('Settings updated.');
                };
                return OrganizationDetailsESaskaitaViewModel;
            }());
            Organizations.OrganizationDetailsESaskaitaViewModel = OrganizationDetailsESaskaitaViewModel;
        })(Organizations = Sys.Organizations || (Sys.Organizations = {}));
    })(Sys = app.Sys || (app.Sys = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Sys;
    (function (Sys) {
        var Organizations;
        (function (Organizations) {
            'use strict';
            var OrganizationDetailsOpusCapitaViewModel = (function () {
                function OrganizationDetailsOpusCapitaViewModel() {
                    this.enabled = ko.observable();
                }
                OrganizationDetailsOpusCapitaViewModel.prototype.done = function () {
                    app.alert.success('Settings updated.');
                };
                return OrganizationDetailsOpusCapitaViewModel;
            }());
            Organizations.OrganizationDetailsOpusCapitaViewModel = OrganizationDetailsOpusCapitaViewModel;
        })(Organizations = Sys.Organizations || (Sys.Organizations = {}));
    })(Sys = app.Sys || (app.Sys = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Sys;
    (function (Sys) {
        var Organizations;
        (function (Organizations) {
            'use strict';
            var OrganizationDetailsP40MvsgViewModel = (function () {
                function OrganizationDetailsP40MvsgViewModel(model) {
                    var _this = this;
                    this.id = ko.observable();
                    this.enabled = ko.observable();
                    this.remoteSystems = ko.observableArray();
                    this.remoteSystemId = ko.observable();
                    this.id(model.p40Mvsg.id);
                    this.enabled(model.p40Mvsg.enabled);
                    app.datasource.remoteSystems(Organizations.RemoteSystemType.MvSteelGroup).done(this.remoteSystems)
                        .then(function () { return _this.remoteSystemId(model.p40Mvsg.remoteSystemId); });
                }
                OrganizationDetailsP40MvsgViewModel.prototype.done = function () {
                    app.alert.success('Settings updated.');
                };
                return OrganizationDetailsP40MvsgViewModel;
            }());
            Organizations.OrganizationDetailsP40MvsgViewModel = OrganizationDetailsP40MvsgViewModel;
        })(Organizations = Sys.Organizations || (Sys.Organizations = {}));
    })(Sys = app.Sys || (app.Sys = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Sys;
    (function (Sys) {
        var Organizations;
        (function (Organizations) {
            'use strict';
            var OrganizationDetailsRivileViewModel = (function () {
                function OrganizationDetailsRivileViewModel() {
                    this.enabled = ko.observable();
                }
                OrganizationDetailsRivileViewModel.prototype.done = function () {
                    app.alert.success('Settings updated.');
                };
                return OrganizationDetailsRivileViewModel;
            }());
            Organizations.OrganizationDetailsRivileViewModel = OrganizationDetailsRivileViewModel;
        })(Organizations = Sys.Organizations || (Sys.Organizations = {}));
    })(Sys = app.Sys || (app.Sys = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Sys;
    (function (Sys) {
        var Organizations;
        (function (Organizations) {
            'use strict';
            (function (RemoteSystemType) {
                RemoteSystemType[RemoteSystemType["MvSteelGroup"] = 1] = "MvSteelGroup";
            })(Organizations.RemoteSystemType || (Organizations.RemoteSystemType = {}));
            var RemoteSystemType = Organizations.RemoteSystemType;
            var OrganizationDetailsViewModel = (function () {
                function OrganizationDetailsViewModel(model) {
                    var _this = this;
                    this.css = '';
                    this.visible = false;
                    this.opusCapita = new Organizations.OrganizationDetailsOpusCapitaViewModel();
                    this.eSaskaita = new Organizations.OrganizationDetailsESaskaitaViewModel();
                    this.rivile = new Organizations.OrganizationDetailsRivileViewModel();
                    this.customBarcode = new Organizations.OrganizationDetailsCustomBarcodeViewModel();
                    this.customOrganizationSettings = new Organizations.OrganizationCustomOrganizationSettingsViewModel();
                    this.tendersLoaded = false;
                    this.tenders = ko.observableArray();
                    this.bidsLoaded = false;
                    this.bids = ko.observableArray();
                    this.usersLoaded = false;
                    this.users = ko.observableArray();
                    this.loadTenders = function () {
                        if (_this.tendersLoaded)
                            return;
                        _this.tendersLoaded = true;
                        var url = '~/api/sys/organizations/{0}/tenders'.format(_this.id);
                        app.http.get(url).done(_this.tenders);
                    };
                    this.loadBids = function () {
                        if (_this.bidsLoaded)
                            return;
                        _this.bidsLoaded = true;
                        var url = '~/api/sys/organizations/{0}/bids'.format(_this.id);
                        app.http.get(url).done(_this.bids);
                    };
                    this.loadUsers = function () {
                        if (_this.usersLoaded)
                            return;
                        _this.usersLoaded = true;
                        var url = '~/api/sys/organizations/{0}/users'.format(_this.id);
                        app.http.get(url).done(_this.users);
                    };
                    this.edit = function () {
                        app.redirect("~/sys/organizations/edit/" + _this.id);
                    };
                    this.remove = function () {
                        app.dialog.confirmRemove()
                            .then(function () { return app.http.deleteInteractive("~/api/sys/organizations/" + _this.id); })
                            .then(function () { return app.redirect('~/#/sys/organizations'); });
                    };
                    this.populatedemodata = function () {
                        app.dialog.confirm('Confirm', 'Are you sure you want to add demo data?')
                            .then(function () { return app.http.post("~/api/sys/organizations/populatedemodata/" + _this.id); });
                    };
                    this.getAzureBlobStorageUsage = function () {
                        app.http.get("~/api/sys/organizations/getAzureBlobStorageUsage/" + _this.id)
                            .then(function (x) { return app.alert.info(x, 'Azure Blob Storage Usage in GBs'); });
                    };
                    app.mapping.mapObject(model, this);
                    this.p40Mvsg = new Organizations.OrganizationDetailsP40MvsgViewModel(model);
                }
                OrganizationDetailsViewModel.prototype.activate = function () {
                };
                OrganizationDetailsViewModel.prototype.done = function (response) {
                };
                return OrganizationDetailsViewModel;
            }());
            Organizations.OrganizationDetailsViewModel = OrganizationDetailsViewModel;
        })(Organizations = Sys.Organizations || (Sys.Organizations = {}));
    })(Sys = app.Sys || (app.Sys = {}));
})(app || (app = {}));

var app;
(function (app) {
    var Sys;
    (function (Sys) {
        var Currencies;
        (function (Currencies) {
            'use strict';
            var CurrencyListItemViewModel = (function () {
                function CurrencyListItemViewModel(data) {
                    this.exchangeRate = ko.observable().extend({ number: { format: 'n4' } });
                    app.mapping.mapObject(data, this);
                }
                return CurrencyListItemViewModel;
            }());
            Currencies.CurrencyListItemViewModel = CurrencyListItemViewModel;
            var CurrencyListViewModel = (function () {
                function CurrencyListViewModel(data) {
                    var _this = this;
                    this.css = '';
                    this.visible = false;
                    this.list = ko.observableArray();
                    this.getEcbExchangeRates = function () {
                        app.http.getInteractive('~/api/sys/currencies/ecbRates').done(function (response) {
                            var list = _this.list();
                            response.forEach(function (currency) {
                                var line = list.find(function (item) { return item.code === currency.code; });
                                if (line) {
                                    line.exchangeRate(currency.rate);
                                }
                            });
                        });
                    };
                    this.list.factory = function (item) { return new CurrencyListItemViewModel(item); };
                    app.mapping.map(data, this.list);
                }
                CurrencyListViewModel.prototype.activate = function () { };
                CurrencyListViewModel.prototype.done = function () {
                    app.alert.success('Exchange rates updated.');
                };
                CurrencyListViewModel.prototype.toJS = function () {
                    return app.mapping.toJS(this.list());
                };
                return CurrencyListViewModel;
            }());
            Currencies.CurrencyListViewModel = CurrencyListViewModel;
        })(Currencies = Sys.Currencies || (Sys.Currencies = {}));
    })(Sys = app.Sys || (app.Sys = {}));
})(app || (app = {}));
